<template>
   <v-sheet height="99%" class="">
      <!--<v-toolbar elevate-on-scroll color="info lighten-4" >-->
        <v-snackbar v-model="snackbar.model" 
        centered :color="snackbar.color" :timeout="snackbar.timeout"
        >
            <div class="text-h5 text-center">{{snackbar.message}}</div>
        </v-snackbar>
        <v-toolbar hide-on-scroll class="mt-2">
            <v-toolbar-title class="text-h4 font-weight-bold">Campagne Marketing</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab icon @click="startNewCampaign()" v-bind="attrs" v-on="on" color="info" class="neu-glow mr-3">
                        <v-icon large>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span class="font-weight-black">Nuova Campagna</span>
            </v-tooltip>
        </v-toolbar>
        <div v-if="!userDetails">
            <v-row class="text-center mt-16">
                <v-col cols="12">
                        <v-progress-circular
                        :rotate="-90"
                        :size="400"
                        :width="45"
                        indeterminate
                        color="info"
                        >
                        </v-progress-circular>                  
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-form ref="form">
                <v-sheet :max-height="wHeight-50">
                <template>
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <div>
                                <v-card class="mx-2">
                                    <v-card-title class="pb-0">
                                        Elenco Campagne
                                        <!--
                                            <v-switch
                                            class="ml-6"
                                            v-model="active"
                                            inset
                                            color="info"
                                            :true-value="1"
                                            :false-value="0"
                                            :label="active?'Attive':'Terminate'"
                                        ></v-switch>
                                        -->
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            label="Cerca"
                                            v-model="search"
                                            hide-details
                                            outlined
                                            max-width="150"
                                            prepend-inner-icon="mdi-magnify"
                                            class="mr-3"
                                        ></v-text-field>
                                        <v-tooltip top >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    fab
                                                    icon
                                                    :loading="loading"
                                                    v-bind="attrs"
                                                    v-on="on" 
                                                    class="neu-glow mr-6"
                                                    @click="getBasicData()"
                                                    >
                                                    <v-icon large color="warning">mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Refresh</span>
                                        </v-tooltip>                                                                                           
                                    </v-card-title>
                                    <div class="overflow-y-auto" :style="'height:'+(wHeight-295)+'px'">
                                        <div v-if="!filteredCampaigns" class="ma-3 pa-3 text-center text-h5">
                                            <div>Nessuna Campagna Trovata</div>
                                            <div>
                                                <v-btn @click="startNewCampaign()" color="info" class="mt-8">
                                                    Crea una Nuova Campagna
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div v-else-if="!filteredCampaigns.length" class="ma-3 pa-3 text-center text-h5">
                                            <div>Nessuna Campagna Attiva Trovata</div>
                                            <div>
                                                <v-btn @click="startNewCampaign()" color="info" class="mt-8">
                                                    Crea una Nuova Campagna
                                                </v-btn>
                                            </div>
                                        </div>                                        
                                        <v-card v-else-if="filteredCampaigns.length" class="ma-3 pa-3 neu-glow" :class="!c.active?'grey darken-3':''" v-for="(c,ci) in filteredCampaigns" :key="ci">
                                            <v-row class="grey darken-4 mb-3">
                                                <v-col cols="12" class="pb-3">
                                                    <v-card-title>
                                                        <div>                                                            
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon
                                                                        class="ml-3 mr-5"
                                                                        large 
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        color="info"
                                                                        >
                                                                        {{c.icon}}
                                                                    </v-icon>
                                                                </template>
                                                                <span>Campagna {{c.typeName}}</span>
                                                            </v-tooltip>                                                            
                                                        </div>                                                                                                                
                                                        <div>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn
                                                                        fab
                                                                        icon
                                                                        v-bind="attrs"
                                                                        v-on="on"                                                                    
                                                                        class="neu-glow"
                                                                        :style="c.approved?'pointer-events:none':''"     
                                                                        @click="payCampaign()"
                                                                    >
                                                                        <v-icon
                                                                        large 
                                                                        :color="!c.approved?'error':c.ended==1?'error':!c.active?'error':c.hold?'error':c.completed?'grey':'success'"
                                                                        >
                                                                        {{!c.approved?'mdi-cash':c.ended==1?'mdi-clock-end':!c.active?'mdi-delete':!c.approved?'mdi-clock':c.hold?'mdi-pause':c.completed?'mdi-send-check':'mdi-play'}}
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>{{!c.approved?'Non Approvata':c.ended==1?'Terminata':!c.active?'Cancellata':c.hold?'In Pausa':c.completed?'Completata':'In Esecuzione'}}</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="mx-9 text-h5">{{c.name}}</div>
                                                        <div>
                                                            <div class="text-h6 float-left ml-6">({{formatDT(c.parameters.startDate,'dmy')}}</div>
                                                            <div v-if="c.parameters.startDate!=c.parameters.endDate" class="text-h6 float-right">  - {{formatDT(c.parameters.endDate,'dmy')}})</div>
                                                            <div v-else class="text-h6 float-right">)</div>
                                                        </div>                                                        
                                                        <v-spacer></v-spacer>
                                                        <v-tooltip top v-if="c.approved==1&&c.ended==1">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    fab
                                                                    icon
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                    disabled
                                                                    >
                                                                    <v-icon large color="warning">mdi-clock-end</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Campagna Terminata</span>
                                                        </v-tooltip>
                                                        <!--
                                                        <v-tooltip top v-if="c.approved==1">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    fab
                                                                    icon
                                                                    @click="cloneCampaign(c.campaignId)"
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                    >
                                                                    <v-icon large color="warning">mdi-content-copy</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Clona Campagna</span>
                                                        </v-tooltip>
                                                        -->
                                                        <!--
                                                        <v-tooltip top v-else-if="!c.approved">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    @click="payCampaign()"
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    icon 
                                                                    fab
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                    >
                                                                    <v-icon large color="success">mdi-cash</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Approva Campagna</span>
                                                        </v-tooltip>
                                                        -->
                                                        <v-tooltip top v-if="!c.hold&&c.approved&&!c.ended">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    @click="alterCampaign(c.campaignId,'hold')"
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    icon 
                                                                    fab
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                >
                                                                    <v-icon large color="error">mdi-pause</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Sospendi Campagna</span>
                                                        </v-tooltip>
                                                        <v-tooltip top v-else-if="c.hold&&c.approved&&!c.ended">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    @click="alterCampaign(c.campaignId,'resume')"
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    icon 
                                                                    fab
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                >
                                                                    <v-icon large color="success">mdi-play</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Riprendi Campagna</span>
                                                        </v-tooltip>                                          
                                                        <v-tooltip top v-if="!c.approved">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    @click="alterCampaign(c.campaignId,'delete')"
                                                                    v-bind="attrs"
                                                                    v-on="on" 
                                                                    icon 
                                                                    fab
                                                                    class="neu-glow mr-6"
                                                                    active-class="neu-glow-inset"
                                                                >
                                                                    <v-icon large color="error">mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Cancella Campagna</span>
                                                        </v-tooltip>                                                                                    
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    @click="openDialogDetails(c)"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon
                                                                    fab
                                                                    :loading="loadingOpenDetails"
                                                                    class="neu-glow mr-3"
                                                                    active-class="neu-glow-inset"
                                                                >
                                                                    <v-icon large color="info">mdi-magnify</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Dettagli</span>
                                                        </v-tooltip>
                                                    </v-card-title>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3" md="2">
                                                    <v-img
                                                        v-if="userDetails&&!c.URLVideo"
                                                        :src="c.picture?'/static/users/pictures/'+c.picture:'/static/users/pictures/'+userDetails.defaultPicture"
                                                        :lazy-src="c.picture?'/static/users/pictures/'+c.picture:'/static/users/pictures/'+userDetails.defaultPicture"
                                                        max-height="168"
                                                        contain
                                                        >
                                                    </v-img> 
                                                    <template v-else-if="userDetails&&c.URLVideo">
                                                        <iframe width="310" height="172" :src="c.URLVideo" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                                                                   
                                                    </template>
                                                </v-col>
                                                <v-col cols="9" md="10">
                                                    <v-row class="px-2">
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Destinatari</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.recipients)}}
                                                                    <v-icon color="info">mdi-account-group</v-icon>
                                                                </div>
                                                                <!--
                                                                <div class="text-caption" v-if="statistics.cCount">
                                                                    <v-icon color="success" v-if="c.kCount>=(statistics.kCount/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.kCount/(statistics.kCount/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                </div>
                                                                -->
                                                            </v-card>
                                                        </v-col>
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Messaggi</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.kCount)}}
                                                                    <v-icon color="success">mdi-whatsapp</v-icon>
                                                                </div>
                                                                <!--
                                                                <div class="text-caption" v-if="statistics.cCount">
                                                                    <v-icon color="success" v-if="c.kCount>=(statistics.kCount/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.kCount/(statistics.kCount/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                </div>
                                                                -->
                                                            </v-card>
                                                        </v-col>
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Inviati</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.sent)}}
                                                                    <v-icon color="grey">mdi-check</v-icon>
                                                                </div>
                                                                <div class="text-caption" v-if="statistics.sent">
                                                                    <span>Sent Rate: {{(c.sent*100/c.kCount).toFixed(2)}}%</span>
                                                                    <!--
                                                                    <v-icon color="success" v-if="c.sent>=(statistics.sent/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.sent/(statistics.sent/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                    -->
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Consegnati</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.delivered)}}
                                                                    <v-icon color="grey">mdi-check-all</v-icon>
                                                                </div>
                                                                <div class="text-caption" v-if="statistics.delivered">
                                                                    <span>Delivery Rate: {{(c.delivered*100/c.sent).toFixed(2)}}%</span>
                                                                    <!--
                                                                    <v-icon color="success" v-if="c.delivered>=(statistics.delivered/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.delivered/(statistics.delivered/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                    -->
                                                                </div>
                                                            </v-card>
                                                        </v-col>                            
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Letti</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.read)}} 
                                                                    <v-icon color="info">mdi-check-all</v-icon>
                                                                </div>
                                                                <div class="text-caption" v-if="statistics.read">
                                                                    <span>Read Rate: {{(c.read*100/c.sent).toFixed(2)}}%</span>
                                                                    <!--
                                                                    <v-icon color="success" v-if="c.read>=(statistics.read/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.read/(statistics.read/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                    -->
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col>
                                                            <v-card class="pa-2 text-center" style="min-height:120px">
                                                                <div class="text-h5">Clicks</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    {{new Intl.NumberFormat('it-IT').format(c.clicks)}} 
                                                                    <v-icon color="info">mdi-cursor-default-click</v-icon>
                                                                </div>
                                                                <div class="text-caption" v-if="statistics.clicks">
                                                                    <span>Click Rate: {{(c.clicks*100/c.sent).toFixed(2)}}%</span>
                                                                    <!--
                                                                    <v-icon color="success" v-if="c.clicks>=(statistics.clicks/statistics.cCount)">mdi-trending-up</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                                    <span>{{(((c.clicks/(statistics.clicks/statistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                                    -->
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col>
                                                            <v-card class="pa-2 text-center elevation-4" style="min-height:120px">
                                                                <div class="text-h5">Costo Click</div>
                                                                <div class="text-h4 font-weight-black">
                                                                    <span v-if="c.clicks">
                                                                        {{new Intl.NumberFormat('it-IT').format(c.provisionalAmount/c.clicks)}} 
                                                                        <v-icon color="info">mdi-currency-eur</v-icon>
                                                                    </span>
                                                                    <span v-else>
                                                                        N/A <v-icon color="info">mdi-currency-eur</v-icon>
                                                                    </span>
                                                                </div>
                                                                <div class="text-caption" v-if="c.clicks&&statistics.clicks">
                                                                    <v-icon color="success" v-if="(c.provisionalAmount/c.clicks)<=(statistics.provisionalAmount/statistics.clicks)">mdi-trending-down</v-icon>
                                                                    <v-icon v-else color="error">mdi-trending-up</v-icon>
                                                                    <span>{{((((c.provisionalAmount/c.clicks)/(statistics.provisionalAmount/statistics.clicks))-1)*100).toFixed(2)}} %</span>
                                                                </div>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>                                                    
                                                    <v-row>
                                                        <v-col cols="12" class="mt-4">
                                                            <!--<v-card class="pa-2 pt-8">-->
                                                                <v-progress-linear
                                                                    v-model="c.completion"
                                                                    height="20"
                                                                    style="pointer-events:none"
                                                                    :color="c.completion==100?'success':'warning'"
                                                                    >
                                                                    <strong>{{ c.completion||'0.00'}} %</strong>
                                                                </v-progress-linear>
                                                            <!--</v-card>-->
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </div>
                                </v-card>
                            </div>
                        </v-col>
                    </v-row>
                </template>
                </v-sheet>
            </v-form>
        </div>
        <v-navigation-drawer
            v-model="newCampaign"
            absolute
            temporary
            stateless
            right
            width="60%"
            style="min-width:900px"
        >
            <v-expand-transition v-if="!recipients">
                <v-row >
                    <v-col cols="12" class="py-0" > 
                        <v-card class="my-2 mx-8">
                            <v-card-title>Recupero Dati</v-card-title>
                            <v-card-text>
                                <v-expand-transition>
                                <div v-if="loading || stage === 'complete'" class="mt-6">
                                    <!-- Main Progress Bar -->
                                    <v-progress-linear
                                    :value="totalProgress"
                                    :indeterminate="stage === 'parsing'"
                                    height="40"
                                    rounded
                                    :color="stage === 'error' ? 'error' : stage === 'complete' ? 'success' : 'primary'"
                                    class="mb-3"
                                    >
                                    <template v-slot:default="{ value }">
                                        <strong class="white--text">{{ value }}%</strong>
                                    </template>
                                    </v-progress-linear>
                                    
                                    <!-- Stage Indicators -->
                                    <v-row>
                                    <v-col cols="12" md="3">
                                        <v-card outlined>
                                        <v-card-text class="text-center pa-3">
                                            <v-icon 
                                            :color="['uploading', 'downloading', 'parsing', 'complete'].includes(stage) ? 'success' : 'grey'"
                                            >
                                            mdi-cloud-upload
                                            </v-icon>
                                            <div class="text-caption mt-1">Upload</div>
                                            <div class="text-caption font-weight-bold">{{ uploadProgress }}%</div>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                    
                                    <v-col cols="12" md="3">
                                        <v-card outlined>
                                        <v-card-text class="text-center pa-3">
                                            <v-icon 
                                            :color="['downloading', 'parsing', 'complete'].includes(stage) ? 'success' : 'grey'"
                                            >
                                            mdi-cloud-download
                                            </v-icon>
                                            <div class="text-caption mt-1">Download</div>
                                            <div class="text-caption font-weight-bold">
                                            {{ downloadProgress }}%
                                            </div>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                    
                                    <v-col cols="12" md="3">
                                        <v-card outlined>
                                        <v-card-text class="text-center pa-3">
                                            <v-icon 
                                            :color="['parsing', 'complete'].includes(stage) ? 'success' : 'grey'"
                                            >
                                            mdi-code-json
                                            </v-icon>
                                            <div class="text-caption mt-1">Parse</div>
                                            <div class="text-caption font-weight-bold">
                                            {{ stage === 'parsing' ? 'Processing...' : stage === 'complete' ? 'Done' : 'Waiting' }}
                                            </div>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                    
                                    <v-col cols="12" md="3">
                                        <v-card outlined>
                                        <v-card-text class="text-center pa-3">
                                            <v-icon 
                                            :color="stage === 'complete' ? 'success' : 'grey'"
                                            >
                                            mdi-database
                                            </v-icon>
                                            <div class="text-caption mt-1">Records</div>
                                            <div class="text-caption font-weight-bold">
                                            {{ allRecipients&&allRecipients.length.toLocaleString() }}
                                            </div>
                                        </v-card-text>
                                        </v-card>
                                    </v-col>
                                    </v-row>
                                    
                                    <!-- Status Message -->
                                    <v-alert 
                                    :type="stage === 'error' ? 'error' : 'info'"
                                    dense
                                    class="mt-3"
                                    >
                                    {{ statusMessage }}
                                    </v-alert>
                                </div>
                                </v-expand-transition>                                  
                            </v-card-text>
                        </v-card> 
                    </v-col>
                </v-row>
            </v-expand-transition>
            <v-expand-transition v-else>
                <v-row class="text-center mt-2">
                    <v-col cols="12" class="py-0"> 
                        <v-card-title class="pb-2" >
                            Nuova Campagna 
                            <v-spacer></v-spacer>
                            <!--
                            <v-progress-linear
                                v-if="!recipients"
                                :height="40"
                                :value="downloadProgress"
                                style="width:50%"
                                color="info"
                            >
                                {{ downloadProgress }} %
                            </v-progress-linear>
                            -->  
                            <v-card class="info darken-3 px-6 py-2">
                                <v-row >
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on" icon class="ml-8">
                                                    {{calculatedRecipients}}
                                                    <v-icon color="info" class="ml-2">mdi-account-group</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Contatti Totali</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-divider vertical class="mx-6"></v-divider>
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on" icon class="mx-2">
                                                    {{filteredRecipients?filteredRecipients.length:0}}
                                                    <v-icon color="info" class="ml-2">mdi-account-check</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Selezionati</span>
                                        </v-tooltip>                                
                                    </v-col>
                                    <v-divider vertical class="mx-6"></v-divider>
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on" icon class="mx-2">
                                                    {{campaign.sendings}}
                                                    <v-icon color="info" class="ml-2">mdi-close</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Invii</span>
                                        </v-tooltip>                                
                                    </v-col>
                                    <v-divider vertical class="mx-6"></v-divider>
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on" icon class="mx-2">
                                                    {{filteredRecipients?filteredRecipients.length*campaign.sendings:0}}
                                                    <v-icon color="success" class="ml-2">mdi-whatsapp</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Totale Messaggi</span>
                                        </v-tooltip>                                
                                    </v-col>
                                    <v-divider vertical class="mx-6"></v-divider>
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on" icon class="mr-8">
                                                    {{campaign.provisionalAmount.toFixed(2)}}
                                                    <v-icon color="info" class="ml-2">mdi-currency-eur</v-icon>
                                                </v-btn>
                                            </template>
                                        <span>Costo Totale</span>
                                        </v-tooltip>                                
                                    </v-col>                                                                                                
                                </v-row>
                            </v-card> 
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span 
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-btn
                                            fab
                                            :loading="loadingSave"
                                            :disabled="errorMessage.length>0||errorDestinee.length>0"
                                            @click="saveCampaign('save')"
                                            icon 
                                            class="neu-glow ml-8"
                                            active-class="neu-glow-inset"
                                        >
                                            <v-icon color="warning">mdi-content-save</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                <span>
                                    <div v-if="errorMessage.length">
                                        <ul>
                                            <li v-for="(e,ei) in errorMessage" :key="ei">
                                                {{e}}
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else>Salva Campagna</div> 
                                </span>              
                            </v-tooltip>                         
                            <v-tooltip top >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        fab
                                        icon
                                        :disabled="loadingSave"
                                        @click="newCampaign=false;loadingSave=false" 
                                        v-bind="attrs" 
                                        v-on="on" 
                                        class="neu-glow ml-8"
                                        active-class="neu-glow-inset"
                                        >
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span class="font-weight-black">Chiudi</span>
                            </v-tooltip>                    
                        </v-card-title>
                    </v-col>
                    <v-col cols="12" class="overflow-y-auto" :style="'height:'+(wHeight-192)+'px'">
                        <v-card class="pa-2 mx-2">
                            <v-row>
                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="12"  class="text-center">
                                            <v-card class="pb-3">
                                                <v-card-title>Tipo Campagna</v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col>
                                                            <v-btn-toggle
                                                                v-model="campaign.type"
                                                                dense
                                                                active-class="info"
                                                                >
                                                                <div>
                                                                    <v-btn class="px-2 ma-1" v-for="(d,di) in campaignTypes" :value="d.code" :key="di">
                                                                    {{d.name}}
                                                                    </v-btn>
                                                                </div>
                                                            </v-btn-toggle>
                                                        </v-col>
                                                    </v-row>                                               
                                                </v-card-text>
                                                <v-row class="mx-16" v-if="campaign.type&&(campaign.type=='birthdays')">
                                                    <v-alert dismissible dense type="warning" class="mt-4 black--text">
                                                        <v-row>
                                                            <v-col class="text-justify">
                                                                Attenzione! Per questo tipo di Campagna i seguenti valori sono da considerare come limite inferiore (annuo), in quanto vengono ricalcolati ogni giorno includendo i nuovi contatti.
                                                            </v-col>
                                                            <v-col class="text-justify">
                                                                La fatturazione avviene mensilmente. Potete sospendere/cancellare la campagna in qualsiasi momento cliccando sul pulsante <v-btn icon> <v-icon color="error" small>mdi-pause</v-icon></v-btn>.
                                                            </v-col>
                                                        </v-row>
                                                    </v-alert>
                                                </v-row>
                                                <v-row class="mx-16" v-else-if="campaign.type&&(campaign.type!='default')">
                                                    <v-alert dismissible dense type="warning" class="mt-4 black--text">
                                                        <v-row>
                                                            <v-col>
                                                                Attenzione! Per questo tipo di Campagna i seguenti valori sono da considerare come limite inferiore (annuo). In funzione delle impostazioni e delle prenotazioni, durante l'anno potrebbero venire inviati più messaggi allo stesso numero.
                                                            </v-col>
                                                            <v-col>
                                                                La fatturazione avviene mensilmente. Potete sospendere/cancellare la campagna in qualsiasi momento cliccando sul pulsante <v-btn icon> <v-icon color="error" small>mdi-pause</v-icon></v-btn>.
                                                            </v-col>
                                                        </v-row>
                                                    </v-alert>
                                                </v-row>                                            
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" md="12" class="mx-16 pb-0">
                                            <v-text-field
                                                v-model="campaign.name"
                                                label="Nome Campagna"
                                                background-color="red darken-2"
                                                outlined
                                                counter
                                                hint="Riferimento Interno: non viene visto dal Cliente"
                                            ></v-text-field>
                                        </v-col>
                                        <template v-if="campaign.type=='default'||campaign.type=='newsletter'">
                                            <v-col cols="12" md="12" class="text-center">
                                                <v-card>
                                                    <v-card-title>Numero Invii</v-card-title>
                                                    <v-slider
                                                        v-model="campaign.sendings"
                                                        hide-details
                                                        :max="12"
                                                        :min="1"
                                                        ticks="always"
                                                        tick-size="4"
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center mt-6 px-16"
                                                        >
                                                    </v-slider>
                                                </v-card>
                                            </v-col>
                                            <v-col v-if="campaign.type=='default'||campaign.type=='newsletter'" cols="12" md="12" class="text-center">
                                                <v-card>
                                                    <v-card-title>Massimo Messaggi per Invio</v-card-title>
                                                    <v-slider
                                                        v-model="campaign.maxMessages"
                                                        hide-details
                                                        :max="1200"
                                                        :min="50"
                                                        :step="50"
                                                        ticks="always"
                                                        tick-size="4"
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center mt-6 px-16"
                                                        >
                                                    </v-slider>
                                                </v-card>
                                            </v-col>                                    
                                            <v-col cols="12" md="12" v-if="campaign.sendings>1">
                                                <v-card class="pa-2 text-center">
                                                    <v-card-title>Frequenza Invii </v-card-title>
                                                    <v-select
                                                        v-model="campaign.frequency"
                                                        :items="frequencies||[]"
                                                        label="Frequenza Invii"
                                                        solo
                                                        ></v-select>
                                                </v-card>
                                            </v-col>
                                        </template>                                   
                                        <v-col cols="12" md="12">
                                            <v-card class="pa-4">
                                                <v-card-title>{{campaign.sendings==1?'Data Inizio Campagna':'Inizio e Fine Campagna'}}</v-card-title>
                                                <v-menu
                                                    v-model="startDate"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="450"
                                                    min-width="auto"
                                                    >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                        v-model="campaign.startDate"
                                                        label="Data Inizio Campagna"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        persistent-hint
                                                        :hint="'Inizio effettivo: '+formatDT(calculatedStartDate,'ddmy')"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="campaign.startDate"
                                                        full-width
                                                        :first-day-of-week="1"
                                                        locale="it-it"
                                                        color="info"
                                                        @input="startDate = false"
                                                        hide-details
                                                        ></v-date-picker>
                                                </v-menu>
                                                <div v-if="campaign.sendings>1" class="mt-3 pt-3">
                                                    <v-menu
                                                        v-model="endDate"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="450"
                                                        min-width="auto"
                                                        >
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="campaign.endDate"
                                                            label="Data Fine Campagna"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                        v-model="campaign.endDate"
                                                        full-width
                                                        :first-day-of-week="1"
                                                        locale="it-it"
                                                        color="info"
                                                        readonly
                                                        max-width="200"
                                                        @input="endDate = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </div>
                                                <v-col cols="12" v-if="campaign.frequency!='day_1'&&campaign.type=='default'||campaign.type=='newsletter'">
                                                    <v-divider class="mt-8 mb-2"></v-divider>
                                                    <v-card class="pa-2 text-center">
                                                        <v-card-title>Giorno Invio</v-card-title>
                                                        <v-btn-toggle
                                                        v-model="campaign.dow"
                                                        dense
                                                        active-class="info"
                                                        >
                                                        <div>
                                                            <v-btn class="px-2 ma-1" v-for="(d,di) in dows" :key="di" :value="d.code">
                                                                {{d.short}}
                                                            </v-btn>
                                                        </div>
                                                        </v-btn-toggle>
                                                    </v-card>                                        
                                                </v-col>                                            
                                                <v-col cols="12">
                                                    <v-card class="pa-2 text-center">
                                                        <div class="pt-2 text-center">
                                                            <v-card-title>Ora invio</v-card-title>
                                                            <v-time-picker
                                                                v-model="campaign.time"
                                                                format="24hr"
                                                                landscape
                                                                scrollable
                                                                :min="minTime"
                                                                max="20:00"
                                                                color="info"
                                                                >
                                                            </v-time-picker>
                                                        </div>
                                                    </v-card>
                                                </v-col>                                            
                                                <template v-if="campaign.type=='birthdays'">
                                                    <v-divider class="mt-8 mb-2"></v-divider>
                                                    <v-card-title>
                                                    Giorni (del compleanno) senza Invio
                                                    <v-spacer></v-spacer>
                                                    <!--
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-switch
                                                                inset
                                                                color="info"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                :label="campaign.excludeHoliday?'Escludi anche Festività':'Festività Incluse'"                                                        
                                                                v-model="campaign.excludeHoliday"
                                                                v-bind="attrs"
                                                                v-on="on" icon class="mr-2">
                                                            </v-switch>
                                                        </template>
                                                        <span>Escludi Festività</span>
                                                    </v-tooltip>
                                                    -->
                                                    
                                                    </v-card-title>
                                                    <div class="text-center">
                                                    <v-btn-toggle
                                                        v-model="campaign.dowsExcluded"
                                                        dense
                                                        multiple
                                                        active-class="error"
                                                        >
                                                        <div>
                                                            <v-btn class="px-2 ma-1" v-for="(d,di) in dows" :key="di">
                                                                {{d.short}}
                                                            </v-btn>
                                                        </div>
                                                    </v-btn-toggle>
                                                    </div>
                                                </template>
                                                <template v-if="campaign.type=='missing'">
                                                    <v-divider class="mt-8 mb-2"></v-divider>
                                                    <v-card-title>Giorni di Assenza</v-card-title>
                                                    <v-slider
                                                        v-model="campaign.daysMissing"
                                                        hide-details
                                                        :max="100"
                                                        :min="1"
                                                        :step="1"
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center mt-6 px-16"
                                                    >
                                                    </v-slider>

                                                </template>                                            
                                                <template v-if="campaign.type=='birthdays'||campaign.type=='missing'">
                                                    <v-divider class="mt-8 mb-2"></v-divider>
                                                    <v-card-title>Giorni di Anticipo rispetto all'Evento</v-card-title>
                                                    <v-slider
                                                        v-model="campaign.daysBeforehand"
                                                        hide-details
                                                        :max="campaign.type=='missing'?10:30"
                                                        :min="campaign.type=='missing'?1:7"
                                                        :step="1"
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center mt-6 px-16"
                                                    >
                                                    </v-slider>
                                                    <v-divider class="mt-8 mb-2"></v-divider>
                                                    <v-card-title>Numero Massimo Messaggi Giornalieri</v-card-title>
                                                    <v-slider
                                                        v-model="campaign.maxDailyMessages"
                                                        hide-details
                                                        :max="200"
                                                        :min="10"
                                                        :step="10"
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center mt-6 px-16"
                                                    >
                                                    </v-slider>
                                                </template>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="my-6 mx-2">
                            <v-row class="text-left">
                                <v-col cols="6">
                                    <v-card-title>WhatsApp Template</v-card-title>
                                    <v-row>
                                        <v-col cols="12"
                        
                                        >
                                        <v-card min-height="450" class="ma-2 pa-2">
                                            <v-img
                                                v-if="userDetails"
                                                class="not_white--text"
                                                height="300px"
                                                contain
                                                :src="'/static/users/pictures/'+userDetails.defaultPicture"
                                                :lazy-src="'/static/users/pictures/'+userDetails.defaultPicture"
                                                >
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" icon @click="dialog_vuecropper=true" class="float-right ma-5 mr-12 align-baseline">
                                                        <v-icon x-large color="red" class="pa-1 ">mdi-image-edit</v-icon>
                                                    </v-btn>
                                                    </template>
                                                    <span>Modifica Immagine</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" icon @click="dialog_inputVideo=true" class="float-right ma-5 align-baseline">
                                                        <v-icon x-large color="red" class="pa-1 ">mdi-video</v-icon>
                                                    </v-btn>
                                                    </template>
                                                    <span>Inserisci Link Video</span>
                                                </v-tooltip>                                        
                                            </v-img>
                                            <v-card-text class="pb-2 pt-2">
                                                <v-text-field
                                                    label="Titolo"
                                                    v-model="campaign.title"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    background-color="#666"
                                                    >
                                                </v-text-field>
                                            </v-card-text>
                                            <v-card-title class="pb-2 text-caption text-left">
                                                Gentile Mario Rossi,
                                                <template v-if="campaign.type=='birthdays'">
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn  v-bind="attrs" v-on="on" x-small color="info" fab icon class="neu-glow">
                                                                <v-icon color="info">mdi-information</v-icon>
                                                            </v-btn>                                                      
                                                        </template>
                                                        <span>
                                                            <div>Per inserire l'Età nel testo usare #age#, per il giorno del compleanno usare #birthdate# e per il nome usare #name#</div>
                                                            <div>Esempio: "Buon #age#° Compleanno #name#!"</div>
                                                            <div>Verrà trasformato in </div>
                                                            <div>Buon 37° Compleanno Giovanna!</div>
                                                            <div>Mentre "Ti aspettiamo il #birthdate#</div>
                                                            <div>Verrà trasformato in </div>
                                                            <div>Ti aspettiamo il 23 Maggio</div>
                                                        <span>
                                                    </v-tooltip>
                                                </template>
                                                <template v-else>
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn  v-bind="attrs" v-on="on" x-small color="info" fab icon class="neu-glow">
                                                                <v-icon color="info">mdi-information</v-icon>
                                                            </v-btn>                                                      
                                                        </template>
                                                        <span>
                                                            <div>per template personalizzato inserire [--estensione_template]</div>
                                                            <div>Esempio: "--bellavida"</div>
                                                        <span>
                                                    </v-tooltip>                                            
                                                </template>  
                                            </v-card-title>
                                            <v-card-text class="pb-2 pt-0">
                                                <v-textarea
                                                    label="Testo 1"
                                                    v-model="campaign.body1"
                                                    solo
                                                    :counter="250"
                                                    auto-grow
                                                    :rows="1"
                                                    clear-icon="mdi-delete"
                                                    dense
                                                    class="text-caption"
                                                    background-color="red lighten-1"
                                                    hint="gli 'a capo' vengono trasformati in spazio"
                                                    >
                                                </v-textarea>
                                            </v-card-text>
                                            <v-card-text class="pt-0 pb-2">
                                                <v-textarea
                                                    label="Testo 2"
                                                    v-model="campaign.body2"
                                                    outlined
                                                    :counter="250"
                                                    auto-grow
                                                    :rows="1"
                                                    clearable
                                                    clear-icon="mdi-delete"
                                                    background-color="#666"
                                                    dense
                                                    class="text-caption"
                                                    hint="gli 'a capo' vengono trasformati in spazio"
                                                    >
                                                </v-textarea>
                                            </v-card-text>
                                            <v-card-text class="pt-0 pb-2">
                                                <v-textarea
                                                    label="Testo 3"
                                                    v-model="campaign.body3"
                                                    outlined
                                                    :counter="250"
                                                    auto-grow
                                                    :rows="1"
                                                    clearable
                                                    clear-icon="mdi-delete"
                                                    background-color="#666"
                                                    dense
                                                    class="text-caption"
                                                    hint="gli 'a capo' vengono trasformati in spazio"
                                                    >
                                                </v-textarea>
                                            </v-card-text>                                    
                                            <v-card-text class="pt-0 pb-2 text-caption">
                                                Grazie 
                                                <br>lo Staff di 
                                                <br>{{userDetails&&userDetails.brand}}
                                            </v-card-text>
                                            <v-card class="pa-2 grey darken-3" v-if="campaign.body1.startsWith('--')">
                                                <v-card-text>
                                                    Assicurarsi di aver creato logica specifica del template personalizzato in send_mktg.php riga 159 e segg
                                                </v-card-text>

                                                <v-card  v-for="(b,bi) in templates" class="mb-4" :key="bi">
                                                    <v-row>
                                                        <v-col cols="6" class="align-content-center">
                                                            <v-radio
                                                                color="info"
                                                                :label="b.buttons.length+' Pulsanti'"
                                                                :value="b.templateId"
                                                            >
                                                            </v-radio>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>



                                            </v-card>
                                            <v-card class="pa-2 grey darken-3" v-else>
                                                <v-card-title>
                                                    Scegli il Gruppo di Pulsanti da inserire
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-radio-group v-model="campaign.templateId" mandatory class="my-n3 py-0">
                                                        <v-card  v-for="(b,bi) in templates" class="mb-4" :key="bi">
                                                            <v-row>
                                                                <v-col cols="10" class="px-1 py-4 text-center">
                                                                    <v-btn small elevation="4" v-for="(bb,bbi) in b.buttons" :key="bbi" class="mx-1 pointer-events-none">
                                                                        {{bb.text}}
                                                                    </v-btn>
                                                                    <template v-if="campaign.templateId===b.templateId">
                                                                        <template v-for="(bb,bbi) in b.buttons" >
                                                                            <v-col cols="12" v-if="bb.urlInput" :key="bbi">
                                                                                <v-text-field
                                                                                    label="Link"
                                                                                    v-model="campaign.link"
                                                                                    :hint="'Link per pulsante '+bb.text"
                                                                                    outlined
                                                                                    dense
                                                                                    background-color="red lighten-1"
                                                                                    class="px-1 text-caption"
                                                                                    >
                                                                                </v-text-field>
                                                                            </v-col>
                                                                        </template>
                                                                    </template>
                                                                </v-col>
                                                                <v-col cols="2" class="align-content-center">
                                                                    <v-radio
                                                                        color="info"
                                                                        :value="b.templateId"
                                                                        >
                                                                    </v-radio>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                    </v-radio-group>
                                                </v-card-text>
                                            </v-card>
                                        </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="6">
                                    <v-card-title>Preview</v-card-title>
                                    <v-row>
                                        <v-col cols="12">
                                        <v-card min-height="450" class="ma-2 pa-2">
                                            <template v-if="userDetails&&campaign.URLVideo">
                                                <iframe width="520" height="292" :src="campaign.URLVideo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </template>
                                            <template v-else>
                                                <v-img
                                                    class="not_white--text"
                                                    height="300px"
                                                    contain
                                                    :aspect-ratio="1" 
                                                    :src="campaign.picture?'/static/users/pictures/'+campaign.picture:'https://smallseotools.co.uk/placeholder/520x300/D5D5D5/584959'"
                                                    :lazy-src="campaign.picture?'/static/users/pictures/'+campaign.picture:'https://smallseotools.co.uk/placeholder/520x300/D5D5D5/584959'"
                                                    >
                                                </v-img>
                                            </template>                                        
                                            <template v-if="userDetails&&campaign.body1.substring(0,2)!='--'">
                                                <v-card-text class="pb-2 font-weight-bold">
                                                    {{campaign.title?campaign.title.replace(/#name#/g, 'Mario').replace(/#age#/g, '38').replace(/#birthdate#/g, formatDT(null,'dmy')):userDetails&&userDetails.brand}}
                                                </v-card-text>
                                                <v-card-text class="pb-2">
                                                    Gentile [Nome Cognome]
                                                </v-card-text>
                                                <v-card-text class="pb-2 pt-0">
                                                        <span v-html="campaign.body1.replace(/#name#/g, 'Mario').replace(/#age#/g, '38').replace(/#birthdate#/g, formatDT(null,'dmy'))"></span>
                                                </v-card-text>
                                                <v-card-text class="pb-2 pt-0">
                                                    <span v-html="campaign.body2.replace(/#name#/g, 'Mario').replace(/#age#/g, '38').replace(/#birthdate#/g, formatDT(null,'dmy'))"></span>
                                                </v-card-text>
                                                <v-card-text class="pb-2 pt-0">
                                                    <span v-html="campaign.body3.replace(/#name#/g, 'Mario').replace(/#age#/g, '38').replace(/#birthdate#/g, formatDT(null,'dmy'))"></span>
                                                </v-card-text>                                    
                                                <v-card-text class="pb-2">
                                                    Grazie 
                                                    <br>
                                                    Lo Staff di 
                                                    <br><strong>{{userDetails.brand}}</strong>
                                                </v-card-text>
                                                <v-card-text class="d-flex justify-lg-space-around">
                                                    <v-row class="no-gutters">
                                                        <!--
                                                        <div>
                                                            {{campaign.templateId}} - {{templates}}
                                                        </div>
                                                        -->
                                                        <template  v-if="campaign.templateId">
                                                            <v-col
                                                                :cols="12/templates.find(b=>b.templateId==campaign.templateId).buttons.length"  
                                                                v-for="(b,bi) in templates.find(b=>b.templateId==campaign.templateId).buttons" 
                                                                :key="bi" 
                                                                class="px-1"
                                                            >
                                                                <v-btn block class="my-1">
                                                                    {{b.text}}
                                                                </v-btn>
                                                            </v-col>
                                                        </template>
                                                    </v-row>
                                                </v-card-text>
                                            </template>
                                            <template v-else>
                                                <v-card-text class="pb-2 font-weight-bold text-h4 text-center">
                                                    Testo e Pulsanti <br /> come da template <br /> {{campaign.body1}}
                                                </v-card-text>
                                            </template>
                                        </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="neu-glow ma-2 green darken-4" v-if="campaign.type!='default'">
                            <v-card-title>Bonus
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn  v-bind="attrs" v-on="on" x-large color="info" fab icon class="neu-glow">
                                            <v-icon color="info">mdi-information</v-icon>
                                        </v-btn>                                                      
                                    </template>
                                    <span>Qualora sia previsto un bonus nel testo del messaggio WhatsApp, è necessario riportarlo anche in questo campo per poterlo gestire in futuro</span>
                                </v-tooltip>                              
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="8">
                                        <v-text-field
                                            label="Bonus"
                                            v-model="campaign.bonus"
                                            outlined
                                            dense
                                            hint="Bonus Offerto"
                                        >
                                        
                                        </v-text-field> 
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            label="Durata Bonus (giorni)"
                                            v-model="campaign.bonusDuration"
                                            outlined
                                            dense
                                            type="number"
                                            reverse
                                            hint="Durata Bonus"
                                        >
                                        
                                        </v-text-field> 
                                    </v-col>
                                </v-row>                                                            
                                                            
                            </v-card-text>

                        </v-card>
                        <v-card class="pa-2 mx-2 mb-3 elevation-5 red darken-2" v-if="newCampaign">
                            <v-card-title class="black--text">
                                Escludi
                            </v-card-title>

                            <v-tabs
                                v-model="excludedFilterTab"
                                align-with-title
                                background-color="red darken-2"
                            >
                                <v-tabs-slider color="black"></v-tabs-slider>
                    
                                <v-tab
                                    v-for="(s,si) in excludedFilters"
                                    :key="si"
                                    class="text-subtitle-1 black--text"
                                >
                                {{ s }}
                                </v-tab>
                            </v-tabs>
                    
                            <v-tabs-items class="red darken-2" v-model="excludedFilterTab">                           
                                <v-tab-item class="pb-2">
                                    <v-card  class="mt-4 mx-2 pa-2 elevation-5 red darken-2">
                                        <v-card-title>Escludi Clienti che hanno ricevuto almeno una delle seguenti Campagne:
                                        </v-card-title>
                                        <v-row>
                                            <v-col>
                                                <v-data-table
                                                    v-model="excludedCampaigns"
                                                    :headers="excludedCampaignHeader"
                                                    :items="campaigns"
                                                    show-select
                                                    :single-select="false"
                                                    item-key="campaignId"
                                                    class="elevation-5 red darken-2"
                                                    style="margin:20px"
                                                    footer-props="{red darken-2}"
                                                > 
                                                </v-data-table>
                                            </v-col>   
                                        </v-row>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card class="my-4 mx-2 pa-2 elevation-5">
                                        <v-card-title class="text-left text-h5">Black List
                                            <v-spacer></v-spacer>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn  v-bind="attrs" v-on="on" x-large color="info" fab icon class="neu-glow" @click="dialog_addBlackList=true">
                                                        <v-icon x-large color="info">mdi-plus</v-icon>
                                                    </v-btn>                                                      
                                                </template>
                                                <span>Blocca nuovo Numero</span>
                                            </v-tooltip>                                     
                                        </v-card-title>
                                        <v-card-text>
                                            <v-card class="my-4 mx-2 pa-2 elevation-5">
                                                <v-data-table
                                                    fixed-header
                                                    :headers="blackListHeader"
                                                    :items="blackList||[]"
                                                    :items-per-page="20"
                                                    class="mt-2 pb-2"
                                                    :loading="loading?'info':null"
                                                    no-data-text="Nessun dato presente in archivio"
                                                    no-results-text="Nessun Risultato estratto"
                                                    loading-text="Consultazione archivio: attendi..."
                                                    >                                           
                                                    <template v-slot:[`item.phoneId`]="{ item }">
                                                        <v-btn small icon @click="blackList_edit('delete',item.phoneId)">
                                                            <v-icon color="error">mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>  
                                                                                        
                                                    <template v-slot:[`item.TS`]="{ item }">
                                                        {{formatDT(item.TS,'dmy')}}
                                                    </template>                                                                               
                                                </v-data-table>
                                            </v-card>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>              
                            </v-tabs-items>
                        </v-card>
                        <v-card class="pa-2 mx-2 elevation-5 yellow darken-2 black--text" v-if="recipients">
                            <v-card-title>
                                Scegli Destinatari:
                            </v-card-title>

                                <v-tabs
                                    v-model="sourceFilterTab"
                                    align-with-title
                                    background-color="yellow darken-2"
                                >
                                    <v-tabs-slider color="black"></v-tabs-slider>
                        
                                    <v-tab
                                    v-for="s in sourceFilters"
                                    :key="s"
                                    class="text-subtitle-1 black--text"
                                    >
                                    {{ s }}
                                    </v-tab>
                                </v-tabs>
                        
                            <v-tabs-items class="yellow darken-2" v-model="sourceFilterTab">
                                <v-tab-item class="pb-2">
                                    <v-card  class="mt-4 mx-2 pa-2 elevation-5 yellow lighten-2 black--text">
                                        <v-card-title>Filtri
                                        </v-card-title>
                                        <v-row>
                                            <v-col cols="12" lg="12" v-for="(s,si) in sliders.filter(slider => slider.types.includes(campaign.type))" :key="si" class="mt-n3">
                                                <v-card elevation="5" class="my-2 mx-4 not_white">
                                                    <v-card-title class="mb-2 pt-0">
                                                    {{s.name}}
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on">
                                                                <v-checkbox
                                                                color="info"                                                          
                                                                v-model="s.active"
                                                                ></v-checkbox>
                                                            </div>
                                                        </template>
                                                        <span>Attiva Filtro</span>
                                                    </v-tooltip>
                                                    </v-card-title>
                                                    <v-card-text>
                                                    <v-range-slider
                                                        :disabled="!s.active"
                                                        :key="si"
                                                        v-model="s.range"
                                                        :max="s.max"
                                                        :min="s.min"
                                                        ticks="always"
                                                        tick-size="4"
                                                        hide-details
                                                        thumb-label="always"
                                                        thumb-color="info"
                                                        class="align-center"
                                                        color="info"
                                                        >
                                                        <template v-slot:thumb-label="props" v-if="s.type=='date'">
                                                            <div>
                                                                {{addDays(props.value)}}
                                                            </div>
                                                        </template>
                                                    </v-range-slider>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="py-0" v-if="campaign.type=='default'" >
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>
                                                    Giorno Visita
                                                    <v-spacer></v-spacer>
                                                    <v-btn class="ma-1" icon @click="filters.dows=[]">
                                                        <v-icon color="red">mdi-delete</v-icon>
                                                    </v-btn>
                                                    </v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.dows"
                                                    active-class="info"
                                                    background-color="not_white"
                                                    multiple
                                                    class="d-flex flex-wrap mx-3 justify-center"
                                                    >
                                                    <div class="d-flex flex-wrap justify-centerr">
                                                        <v-btn class="px-2 ma-1" v-for="(d,di) in dows" :key="di" :value="d.code">
                                                            {{d.short}} 
                                                        </v-btn>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="py-0" v-if="campaign.type=='default'">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>Pasto</v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.meal"
                                                    active-class="info"
                                                    multiple
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-center">
                                                        <v-tooltip top  v-for="(g,gi) in meals" :key="gi" disabled>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                <v-icon>{{g.icon}}</v-icon>
                                                                {{g.name}}
                                                                </v-btn>
                                                            </template>
                                                            <span></span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="py-0" v-if="campaign.type=='default'">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>
                                                    Orario
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip top >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" icon @click="filters.slot=[]">
                                                                    <v-icon color="red">mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Pulisci</span>
                                                    </v-tooltip>                                                 
                                                    </v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.slot"
                                                    active-class="info"
                                                    multiple
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-center">
                                                        <v-tooltip top  v-for="(g,gi) in slots" :key="gi"  disabled>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                {{g.name}}
                                                                </v-btn>
                                                            </template>
                                                            <span></span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="py-0" v-if="campaign.type=='default'">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>
                                                    Canale Acquisizione
                                                    <v-spacer></v-spacer>
                                                    <v-tooltip top >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" icon @click="filters.origin=[]">
                                                                    <v-icon color="red">mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Pulisci</span>
                                                    </v-tooltip>                                                
                                                    </v-card-title>
                                                    <v-btn-toggle
                                                        v-model="filters.origin"
                                                        active-class="info"
                                                        background-color="not_white"
                                                        multiple
                                                        class="d-flex flex-wrap mx-3 justify-center"
                                                    >
                                                    <div class="d-flex flex-wrap justify-lg-space-around">
                                                        <v-tooltip top  v-for="(o,oi) in origins" :key="oi">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="o.path">
                                                                <v-icon :color="o.color">{{o.icon}}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{o.name}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" class="py-0">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>
                                                    Nazioni
                                                    <v-spacer></v-spacer>
                                                    <!--
                                                    <v-btn class="ma-1" icon @click="filters.countryId=[]">
                                                        <v-icon color="red">mdi-select-all</v-icon>
                                                    </v-btn>
                                                    -->
                                                    <v-tooltip top >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on"  class="ma-1 ml-3" icon @click="filters.countryId=[]">
                                                                    <v-icon color="red">mdi-delete</v-icon>
                                                                </v-btn> 
                                                            </template>
                                                            <span>Pulisci</span>
                                                    </v-tooltip>                                      
                                                    </v-card-title>
                                                    <v-btn-toggle
                                                        v-model="filters.countryId"
                                                        active-class="info"
                                                        background-color="not_white"
                                                        multiple
                                                        class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                        <div class="d-flex flex-wrap justify-center">
                                                            <v-tooltip :open-on-hover="false" top  v-for="(c,ci) in (recipients.map(item => item.country).filter((value, index, self) => self.indexOf(value) === index))||[]" :key="ci">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="c" min-width="89">
                                                                    <i :class="['mr-2', 'em', 'em-flag-'+c.toLowerCase()]"></i>
                                                                    {{c}}
                                                                    </v-btn>
                                                                </template>
                                                                <span> </span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-btn-toggle>
                                                </v-card>                                
                                            </v-col>
                                            <v-col cols="6" class="py-0">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>Genere</v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.gender"
                                                    active-class="info"
                                                    multiple
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-lg-space-around">
                                                        <v-tooltip top  v-for="(g,gi) in genders" :key="gi">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                <v-icon>{{g.icon}}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{g.name}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="6" class="py-0" v-if="campaign.type=='default'">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>Lista D'Attesa <span class="text-caption pl-2 mt-1">(almeno 1 volta)</span></v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.wl"
                                                    active-class="info"
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-lg-space-around">
                                                        <v-tooltip top  v-for="(g,gi) in waitingLists" :key="gi">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                <v-icon>{{g.icon}}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{g.name}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="6" class="py-0" v-if="campaign.type=='default'">
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>No Show <span class="text-caption pl-2 mt-1">(almeno 1 volta)</span></v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.noShow"
                                                    active-class="info"
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-lg-space-around">
                                                        <v-tooltip top  v-for="(g,gi) in noShows" :key="gi">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                <v-icon>{{g.icon}}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{g.name}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="6" class="py-0 pb-2" v-if="campaign.type=='default'" >
                                                <v-card elevation="5" class="mx-4 my-2 not_white pb-6">
                                                    <v-card-title>Cancellati <span class="text-caption pl-2 mt-1">(almeno 1 volta)</span></v-card-title>
                                                    <v-btn-toggle
                                                    v-model="filters.cancelled"
                                                    active-class="info"
                                                    background-color="not_white"
                                                    class="d-flex flex-wrap mx-3 justify-center transparent-bg"
                                                    >
                                                    <div class="d-flex flex-wrap justify-lg-space-around">
                                                        <v-tooltip top  v-for="(g,gi) in cancelleds" :key="gi">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" class="ma-1" :value="g.code">
                                                                <v-icon>{{g.icon}}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{g.name}}</span>
                                                        </v-tooltip>
                                                    </div>
                                                    </v-btn-toggle>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card class="my-4 mx-2 pa-2 elevation-5">
                                        <v-card-title class="my-0 py-0">
                                            <span  class="text-caption pr-2">Salva Dati</span>
                                            <v-checkbox
                                                v-model="dialog_saveManualData"
                                                color="info"
                                            ></v-checkbox>                                                     
                                            <v-spacer></v-spacer>
                                            <span  class="text-caption">Aggiungi (+)39 a TUTTI i numeri</span>
                                            <v-checkbox
                                                v-model="add39"
                                                color="info"
                                            ></v-checkbox>
                                            <v-btn @click.stop="dialog_errorDestinee=true" fab icon small v-if="errorDestinee&&errorDestinee.length">
                                                <v-icon color="warning">mdi-alert-rhombus</v-icon> 
                                            </v-btn>                                    
                                        </v-card-title>
                                        <v-row no-gutters>
                                            <!--
                                            <v-col cols="12" class="text-right">
                                                    <span  class="text-caption">Aggiunge +39 a TUTTI i numeri</span>
                                                    <v-checkbox
                                                        v-model="add39"
                                                    ></v-checkbox>
                                                    <v-btn @click="dialog_errorDestinee=true" fab icon small v-if="errorDestinee&&errorDestinee.length">
                                                        <v-icon color="warning">mdi-alert-rhombus</v-icon> 
                                                    </v-btn>
                                            </v-col>
                                            -->
                                            <v-col cols="12">
                                                <v-card-text >
                                                    <v-textarea
                                                        v-model="manualRecipients"
                                                        clearable
                                                        auto-grow
                                                        rows="2"
                                                        row-height="15"
                                                        outlined
                                                        color="info"
                                                        clear-icon="mdi-close-circle"
                                                        label="Numeri destinatari"
                                                        :hint="!manualRecipients?'Inserisci i numeri separati da virgola. Il numero deve contenere anche il prefisso nazionale. Eventuali spazi e \'+\' vengono rimossi':'Dati effettivamente inseriti: '+filteredRecipients"
                                                        persistent-hint
                                                        counter
                                                    ></v-textarea>                                      
                                                </v-card-text>
                                            </v-col>
                                            <v-col cols="2" class="d-flex justify-center">

                                            </v-col>
                                        </v-row>

                                        <v-card-text >
                                            <v-textarea
                                                v-model="manualNames"
                                                clearable
                                                auto-grow
                                                rows="2"
                                                row-height="15"
                                                outlined
                                                clear-icon="mdi-close-circle"
                                                label="Nomi destinatari"
                                                hint="Inserisci i nomi separati da virgola. I nomi seguono la sequenza dei numeri. Se assenti l'incipit è 'Gentile Cliente'"
                                                persistent-hint
                                                counter
                                            ></v-textarea>                                      
                                        </v-card-text>                                
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card class="my-4 mx-2 pa-2 elevation-5">
                                        <v-card-title class="text-left text-h5">Seleziona Archivio Salvato
                                            <v-spacer></v-spacer>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn  v-bind="attrs" v-on="on" x-large color="info" fab icon class="neu-glow" @click="dialog_uploadCSV=true">
                                                        <v-icon x-large color="info">mdi-upload</v-icon>
                                                    </v-btn>                                                      
                                                </template>
                                                <span>Carica file CSV</span>
                                            </v-tooltip>                                     
                                        </v-card-title>
                                        <v-card-text>
                                            <v-card class="my-4 mx-2 pa-2 elevation-5">
                                                <v-data-table
                                                    fixed-header
                                                    :headers="savedDataHeader"
                                                    :items="!savedDataArchives?[]:savedDataArchives"
                                                    hide-default-footer
                                                    :items-per-page="500"
                                                    class="mt-2 pb-2"
                                                    :loading="loading?'info':null"
                                                    no-data-text="Nessun dato presente in archivio"
                                                    no-results-text="Nessun Risultato estratto"
                                                    loading-text="Consultazione archivio: attendi..."
                                                    >
                                                    <template v-slot:[`item.dataId`]="{ item }">
                                                        <v-radio-group v-model="selectedDataArchiveId">
                                                        <v-radio
                                                            class="d-flex justify-center"
                                                            :value="item.dataId"
                                                        ></v-radio>
                                                    </template> 
                                                    
                                                    <template v-slot:[`item.dataId2`]="{ item }">
                                                        <v-btn small icon @click="savedDataArchive_Delete(item.dataId)">
                                                            <v-icon color="error">mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>  
                                                                                        
                                                    <template v-slot:[`item.TS`]="{ item }">
                                                        {{formatDT(item.TS,'dmy')}}
                                                    </template>                                                                               
                                                </v-data-table>
                                            </v-card>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>     
                            </v-tabs-items>
                        </v-card>                      
                    </v-col>
                </v-row>
            </v-expand-transition>
        </v-navigation-drawer>
        <v-dialog 
            v-model="dialog_uploadCSV"
            width="1200"
            >
                <v-card class="pa-3 neu-glow">
                    <v-card-title class="text-h3">Carica File CSV
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn icon fab v-bind="attrs" v-on="on" href="/static/users/mktg/csv/MKTG.csv" download="MKTG.csv"><v-icon x-large color="green">mdi-microsoft-excel</v-icon></v-btn>
                            </template>
                            <span>Scarica File Esempio</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="dialog_uploadCSV = false"
                                    v-bind="attrs"
                                    v-on="on" 
                                    icon
                                    fab
                                    class="ml-3" 
                                >
                                    <v-icon x-large color="error">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Chiudi </span>
                        </v-tooltip> 
                    </v-card-title>
                    <v-card-text class="text-center">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn  v-bind="attrs" v-on="on" x-large color="info" fab icon class="neu-glow" @click="dialog_upload=true">
                                    <v-icon x-large color="info">mdi-upload-multiple</v-icon>
                                </v-btn>                                                      
                            </template>
                            <span>Scegli File</span>
                        </v-tooltip>                                                           
                    </v-card-text>
                    <v-card-text>
                        <p class="text-h6">
                            Il file deve essere in formato CSV e contenere solamente 2 campi: nome e numero.
                        <br>
                            Si consiglia di utilizzare il file CSV scaricabile in alto a destra <span class="text-subtitle-1">(cancelllando la riga di esempio "Mario Rossi")</span>.
                        <br><br>
                            Il file si presenta diversamente a seconda dell'applicativo con il quale viene aperto:
                        </p>
                        <v-row>
                            <v-col class="text-h4">
                                <v-card class="ma-2 pa-6 neu-glow" elevation="10">
                                    <div class=" text-center">Excel</div>
                                    <div class="text-h6 mt-2">
                                        Con Excel, la cella A1 deve contenere <strong class="info--text">nome</strong> e la cella B1 deve contenere <strong class="info--text">telefono</strong>
                                    </div>
                                    <v-img
                                        width="400"
                                        class="mx-auto mt-3"
                                        src="/static/users/mktg/excel_mktg.png"
                                        lazy-src="/static/users/mktg/excel_mktg.png"
                                        >
                                    </v-img>                                      
                                </v-card>                            
                            </v-col>
                            <v-col class="text-h4">
                                <v-card class="ma-2 pa-6 neu-glow" elevation="10">
                                    <div class=" text-center">NotePad</div>
                                    <div class="text-h6 mt-2">
                                        Con un text editor (NotePad o altri), la prima riga deve contenere <strong class="info--text">nome,telefono</strong>
                                    </div>
                                    <v-img
                                        width="400"
                                        class="mx-auto mt-3"
                                        src="/static/users/mktg/notepad_mktg.png"
                                        lazy-src="/static/users/mktg/notepad_mktg.png"
                                        >
                                    </v-img>                                     
                                </v-card>
                            </v-col>
                        </v-row>
                        <!--
                        <v-row>
                            <v-col>
                                <v-img
                                    width="400"
                                    class="mx-auto"
                                    src="/static/users/mktg/excel_mktg.png"
                                    lazy-src="/static/users/mktg/excel_mktg.png"
                                    >
                                </v-img>                                
                            </v-col>
                            <v-col>
                                <v-img
                                    width="400"
                                    class="mx-auto"
                                    src="/static/users/mktg/notepad_mktg.png"
                                    lazy-src="/static/users/mktg/notepad_mktg.png"
                                    >
                                </v-img>                                    
                            </v-col>
                        </v-row>
                        -->
                        <p class="text-h6 mt-4">
                            Nota: Tutti i caratteri non numerici presenti nella colonna B vengono eliminati automaticamente.
                        </p>
                    </v-card-text>
                </v-card>
        </v-dialog>        
        <v-dialog 
            v-model="dialog_details"
            fullscreen
            hide-overlay
            v-if="selectedCampaign"
            >
            <v-card>
                <v-card-title class="text-h5 grey darken-4 mb-3">
                Dettagli Campagna "<span class="font-weigth-bold">{{selectedCampaign.name}}</span>"
                <v-spacer></v-spacer>
                <!--
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="cloneCampaign(selectedCampaign.campaignId)"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            fab 
                            class="neu-glow mr-2"
                            active-class="neu-glow-inset"
                        >
                            <v-icon color="info">mdi-content-copy</v-icon>
                        </v-btn>
                    </template>
                    <span>Clona Campagna</span>
                </v-tooltip>
                -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="dialog_details = false"
                            v-bind="attrs"
                            v-on="on" 
                            icon
                            fab 
                            class="neu-glow mr-2"
                            active-class="neu-glow-inset"
                        >
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi </span>
                </v-tooltip>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6" class="mb-2" :style="'max-height:'+(wHeight-124)+'px;overflow-y:auto'">
                            <v-card class="pa-2 neu-glow">
                                <div v-if="campaignDetails">
                                    <v-row class="px-2">
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow" style="min-height:120px">
                                                <div class="text-h5">Messaggi</div>
                                                <div class="text-h6 font-weight-black">
                                                    {{new Intl.NumberFormat('it-IT').format(campaignDetails.kCount)}}
                                                    <v-icon color="success">mdi-whatsapp</v-icon>
                                                </div>
                                                <div class="text-caption" v-if="campaignStatistics.cCount">
                                                    <v-icon color="success" v-if="campaignDetails.kCount>=(campaignStatistics.kCount/campaignStatistics.cCount)">mdi-trending-up</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                    <span>{{(((campaignDetails.kCount/(campaignStatistics.kCount/campaignStatistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow" style="min-height:120px">
                                                <div class="text-h5">Inviati</div>
                                                <div class="text-h6 font-weight-black">
                                                    {{new Intl.NumberFormat('it-IT').format(campaignDetails.sent)}}
                                                    <v-icon color="grey">mdi-check</v-icon>
                                                </div>
                                                <div class="text-caption" v-if="campaignStatistics.sent">
                                                    <v-icon color="success" v-if="campaignDetails.sent>=(campaignStatistics.sent/campaignStatistics.cCount)">mdi-trending-up</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                    <span>{{(((campaignDetails.sent/(campaignStatistics.sent/campaignStatistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow" style="min-height:120px">
                                                <div class="text-h5">Consegnati</div>
                                                <div class="text-h6 font-weight-black">
                                                    {{new Intl.NumberFormat('it-IT').format(campaignDetails.delivered)}}
                                                    <v-icon color="grey">mdi-check-all</v-icon>
                                                </div>
                                                <div class="text-caption" v-if="campaignStatistics.delivered">
                                                    <v-icon color="success" v-if="campaignDetails.delivered>=(campaignStatistics.delivered/campaignStatistics.cCount)">mdi-trending-up</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                    <span>{{(((campaignDetails.delivered/(campaignStatistics.delivered/campaignStatistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>                            
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow" style="min-height:120px">
                                                <div class="text-h5">Letti</div>
                                                <div class="text-h6 font-weight-black">
                                                    {{new Intl.NumberFormat('it-IT').format(campaignDetails.read)}} 
                                                    <v-icon color="info">mdi-check-all</v-icon>
                                                </div>
                                                <div class="text-caption" v-if="campaignStatistics.read">
                                                    <v-icon color="success" v-if="campaignDetails.read>=(campaignStatistics.read/campaignStatistics.cCount)">mdi-trending-up</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                    <span>{{(((campaignDetails.read/(campaignStatistics.read/campaignStatistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow" style="min-height:120px">
                                                <div class="text-h5">Clicks</div>
                                                <div class="text-h6 font-weight-black">
                                                    {{new Intl.NumberFormat('it-IT').format(campaignDetails.clicks)}} 
                                                    <v-icon color="info">mdi-cursor-default-click</v-icon>
                                                </div>
                                                <div class="text-caption" v-if="campaignStatistics.clicks">
                                                    <v-icon color="success" v-if="campaignDetails.clicks>=(campaignStatistics.clicks/campaignStatistics.cCount)">mdi-trending-up</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-down</v-icon>
                                                    <span>{{(((campaignDetails.clicks/(campaignStatistics.clicks/campaignStatistics.cCount))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>
                                        <v-col class="px-1">
                                            <v-card class="pa-2 text-center neu-glow"  style="min-height:120px">
                                                <div class="text-h5">Costo Click</div>
                                                <div class="text-h6 font-weight-black">
                                                    <span v-if="campaignDetails.clicks">
                                                        {{new Intl.NumberFormat('it-IT').format(campaignDetails.provisionalAmount/campaignDetails.clicks)}} 
                                                        <v-icon color="info">mdi-currency-eur</v-icon>
                                                    </span>
                                                    <span v-else>
                                                        N/A
                                                    </span>
                                                </div>
                                                <div class="text-caption" v-if="campaignDetails.clicks&&campaignStatistics.clicks">
                                                    <v-icon color="success" v-if="(campaignDetails.provisionalAmount/campaignDetails.clicks)<=(campaignStatistics.provisionalAmount/campaignStatistics.clicks)">mdi-trending-down</v-icon>
                                                    <v-icon v-else color="error">mdi-trending-up</v-icon>
                                                    <span>{{((((campaignDetails.provisionalAmount/campaignDetails.clicks)/(campaignStatistics.provisionalAmount/campaignStatistics.clicks))-1)*100).toFixed(2)}} %</span>
                                                </div>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row class="mt-3">
                                    <v-col cols="4">
                                        <v-card class="pa-2 neu-glow">
                                            <v-card-title class="py-1">Messaggio WhatsApp</v-card-title>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-card min-height="450" class="ma-2 pa-2">
                                                        <v-img
                                                            v-if="userDetails"
                                                            class="not_white--text"
                                                            height="200px"
                                                            contain
                                                            :src="selectedCampaign.parameters.picture?'/static/users/pictures/'+selectedCampaign.parameters.picture:'/static/user/pictures/'+userDetails.defaultPicture"
                                                            :lazy-src="selectedCampaign.parameters.picture?'/static/users/pictures/'+selectedCampaign.parameters.picture:'/static/user/pictures/'+userDetails.defaultPicture"                                        
                                                            >
                                                        </v-img>
                                                        <v-card-text class="pb-0 font-weight-bold">
                                                            {{selectedCampaign.parameters.title?selectedCampaign.parameters.title:userDetails.brand}}
                                                        </v-card-text>
                                                        <v-card-text class="pb-0">
                                                            Gentile Mario Rossi,
                                                        </v-card-text>
                                                        <v-card-text class="pb-2 pt-0">
                                                                <span v-html="selectedCampaign.parameters.body1"></span>
                                                        </v-card-text>
                                                        <v-card-text class="pb-2 pt-0" v-if="selectedCampaign.parameters.body2">
                                                            <span v-html="selectedCampaign.parameters.body2"></span>
                                                        </v-card-text>
                                                        <v-card-text class="pb-2 pt-0" v-if="selectedCampaign.parameters.body3">
                                                            <span v-html="selectedCampaign.parameters.body3"></span>
                                                        </v-card-text>                                                        
                                                        <v-card-text class="pb-2">
                                                            Grazie 
                                                            <br>
                                                            Lo Staff di 
                                                            <br><strong>{{userDetails.brand}}</strong>
                                                        </v-card-text>
                                                        <v-card-text class="d-flex justify-lg-space-around">
                                                            <v-row class="no-gutters">
                                                                <v-col 
                                                                    v-for="(b,bi) in templates.find(b=>b.templateId==selectedCampaign.parameters.templateId).buttons" :key="bi" class="px-1">
                                                                <v-btn block class="my-1">
                                                                    {{b.text}}
                                                                </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card  class="pa-2 neu-glow">
                                                    <v-card-title>Parametri</v-card-title>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2">Tipo Campagna</v-card-text>
                                                                <v-btn small :key="di"  v-for="(d,di) in campaignTypes.filter(dd=>selectedCampaign.parameters.type.includes(dd.code))">                                                                
                                                                    <v-icon>{{d.icon}}</v-icon>
                                                                    {{d.name}}
                                                                </v-btn>
                                                            </v-card>
                                                        </v-col>                                        
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Inizio</v-card-text>
                                                                
                                                                <v-btn >                                                                
                                                                    {{formatDT(selectedCampaign.parameters.startDate,'dmy')}}
                                                                </v-btn>
                                                            </v-card>
                                                            <!--
                                                            <v-text-field
                                                                label="Inizio Campagna"
                                                                v-model="selectedCampaign.parameters.startDate"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                readonly
                                                                ></v-text-field>
                                                                -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Fine</v-card-text>
                                                                <v-btn>
                                                                    {{formatDT(selectedCampaign.parameters.endDate,'dmy')}}
                                                                </v-btn>
                                                            </v-card>
                                                            <!--
                                                            <v-text-field
                                                                label="Fine Campagna"
                                                                v-model="selectedCampaign.parameters.endDate"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                readonly
                                                                ></v-text-field>
                                                                -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            v-if="selectedCampaign.parameters.dow&&campaign.type=='default'"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Giorno Invio</v-card-text>
                                                                <v-btn>
                                                                    {{selectedCampaign.parameters.dow?dows.find(d=>d.code==selectedCampaign.parameters.dow).short:''}}
                                                                </v-btn>
                                                            </v-card>
                                                            <!--                                                            
                                                            <v-text-field
                                                                label="Giorno Invio"
                                                                v-model="selectedCampaign.parameters.dow"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                readonly
                                                                ></v-text-field>
                                                                -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Ora Invio</v-card-text>
                                                                <v-btn>
                                                                    {{selectedCampaign.parameters.time}}
                                                                </v-btn>                                                                
                                                            </v-card>
                                                            <!--                                                            
                                                            <v-text-field
                                                                label="Ora Invio"
                                                                v-model="selectedCampaign.parameters.time"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                reverse
                                                                readonly
                                                                ></v-text-field>
                                                                -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            v-if="selectedCampaign.parameters.sendings>1"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Frequenza</v-card-text>
                                                                <v-btn>
                                                                    {{selectedCampaign.parameters.frequency||'Settimanale'}}
                                                                </v-btn>                                                                                                                                
                                                            </v-card>                                                            
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Invii</v-card-text>
                                                                <v-btn>
                                                                    {{selectedCampaign.parameters.sendings||1}}
                                                                </v-btn>                                                                 
                                                            </v-card> 
                                                            <!--                                                            
                                                            <v-text-field
                                                                label="Max Invii"
                                                                v-model="selectedCampaign.parameters.sendings"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                reverse
                                                                readonly
                                                                ></v-text-field>
                                                                -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="6"
                                                            md="4"
                                                            >
                                                            <v-card class="pa-2 text-center neu-glow">
                                                                <v-card-text class="mb-2 mr-3">Costo Totale</v-card-text>
                                                                <v-btn>
                                                                    {{selectedCampaign.parameters.provisionalAmount.toFixed(2)}}
                                                                    <v-icon color="info" class="mt-n2 ml-3">mdi-currency-eur</v-icon>
                                                                </v-btn>                                                                
                                                            </v-card>
                                                            <!--
                                                            <v-text-field
                                                                label="Costo Totale Campagna"
                                                                v-model="selectedCampaign.parameters.provisionalAmount"
                                                                hide-details
                                                                outlined
                                                                dense
                                                                reverse
                                                                class="text-h5"
                                                                readonly
                                                                append-outer-icon="mdi-currency-eur"
                                                                ></v-text-field>
                                                            -->
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="selectedCampaign.sliders||selectedCampaign.filters">
                                            <v-col cols="12">
                                                <v-card  color="pa-2 neu-glow">
                                                    <v-card-title>Filtri</v-card-title>
                                                    <v-row>
                                                        <template v-if="selectedCampaign.sliders">
                                                            <v-col
                                                                v-for="(s, si) in selectedCampaign.sliders"
                                                                :key="si"
                                                                cols="6"
                                                                sm="4"
                                                                class="text-center"
                                                            >
                                                                <v-card class="pa-2 neu-glow" style="min-height:148px">
                                                                    <v-card-text class="mb-8">{{s.name}}</v-card-text>
                                                                    <v-range-slider
                                                                        class="px-5"
                                                                        v-model="s.range"
                                                                        thumb-label="always"
                                                                        thumb-color="info"
                                                                        :max="s.range[1]"
                                                                        :min="s.range[0]"
                                                                        readonly
                                                                    ></v-range-slider>
                                                                </v-card>
                                                            </v-col>
                                                        </template>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                             v-if="selectedCampaign.filters&&selectedCampaign.filters.dows&&selectedCampaign.filters.dows.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                                <v-card-text class="mb-6">Giorno</v-card-text>
                                                                <v-btn small :key="di"  v-for="(d,di) in dows.filter(dd=>selectedCampaign.filters.dows.includes(dd.code))">
                                                                    {{d.short}}
                                                                </v-btn>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.meal&&selectedCampaign.filters.meal.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                                <v-card-text class="mb-6">Pasto</v-card-text>
                                                            <v-btn small :key="di"  v-for="(d,di) in meals.filter(dd=>selectedCampaign.filters.meal.includes(dd.code))">
                                                                {{d.name}}
                                                            </v-btn>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.slot&&selectedCampaign.filters.slot.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                            <v-card-text class="mb-6">Slot</v-card-text>
                                                            <v-btn small class="pa-1" :key="di"  v-for="(d,di) in slots.filter(dd=>selectedCampaign.filters.slot.includes(dd.code))">
                                                                {{d.name}}
                                                            </v-btn>

                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.origin&&selectedCampaign.filters.origin.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                            <v-card-text class="mb-6">Canale</v-card-text>
                                                            <v-tooltip top  v-for="(d,di) in origins.filter(dd=>selectedCampaign.filters.origin.includes(dd.path))" :key="di">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn class="pa-1" v-bind="attrs" v-on="on" small :key="di" >
                                                                        <v-icon :color="d.color">{{d.icon}}</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>{{d.name}}</span>
                                                            </v-tooltip>                                                                    
                                                            <!--
                                                            <v-text-field
                                                            label="Canale/i Acquisizione"
                                                            v-model="selectedCampaign.filters.origin"
                                                            hide-details
                                                            outlined
                                                            dense
                                                            readonly
                                                            ></v-text-field>
                                                            -->
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="uniqueCountries&&selectedCampaign.filters&&selectedCampaign.filters.countryId&&selectedCampaign.filters.countryId.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                            <v-card-text class="mb-6">Nazione</v-card-text>
                                                            <v-tooltip top  :key="di"  v-for="(d,di) in uniqueCountries">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn class="pa-1" v-bind="attrs" v-on="on" small >
                                                                        <i :class="['mr-2', 'em', d.flag]"></i>
                                                                        {{d.code}}
                                                                    </v-btn>
                                                                </template>
                                                                <span>{{d.name}}</span>
                                                            </v-tooltip>                                                            
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.gender&&selectedCampaign.filters.gender.length"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                            <v-card-text class="mb-6">Genere</v-card-text>
                                                            <v-btn class="pa-1" small :key="di"  v-for="(d,di) in genders.filter(dd=>selectedCampaign.filters.gender.includes(dd.code))">
                                                                <v-icon>{{d.icon}}</v-icon>
                                                            </v-btn>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.wl"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                                <v-card-text class="mb-2">In Lista</v-card-text>
                                                                <v-switch
                                                                    v-model="selectedCampaign.filters.wl"
                                                                    inset
                                                                    color="info"
                                                                    :true-value="1"
                                                                    :false-value="0"
                                                                    label=""
                                                                    readonly
                                                                    class="d-inline-flex"
                                                                ></v-switch>
                                                            </v-card>
                                                            <!--
                                                            <v-text-field
                                                            label="Lista d'Attesa"
                                                            v-model="selectedCampaign.filters.wl"
                                                            hide-details
                                                            outlined
                                                            dense
                                                            readonly
                                                            ></v-text-field>
                                                            -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.noShow"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                                <v-card-text class="mb-2">No Show</v-card-text>
                                                                <v-switch
                                                                    v-model="selectedCampaign.filters.noShow"
                                                                    inset
                                                                    color="info"
                                                                    :true-value="1"
                                                                    :false-value="0"
                                                                    label=""
                                                                    readonly
                                                                    class="d-inline-flex"
                                                                ></v-switch>
                                                            </v-card>
                                                            <!--
                                                            <v-text-field
                                                            label="No Show"
                                                            v-model="selectedCampaign.filters.noShow"
                                                            hide-details
                                                            outlined
                                                            dense
                                                            readonly
                                                            ></v-text-field>
                                                            -->
                                                        </v-col>
                                                        <v-col
                                                            cols="6"
                                                            sm="4"
                                                            class="text-center"
                                                            v-if="selectedCampaign.filters&&selectedCampaign.filters.nonBooked"
                                                            >
                                                            <v-card class="pa-2 neu-glow" style="min-height:156px">
                                                                <v-card-text class="mb-2">No Prenotato</v-card-text>
                                                                <v-switch
                                                                    v-model="selectedCampaign.filters.nonBooked"
                                                                    inset
                                                                    color="info"
                                                                    :true-value="1"
                                                                    :false-value="0"
                                                                    label=""
                                                                    readonly
                                                                    class="d-inline-flex"
                                                                ></v-switch>
                                                            </v-card> 
                                                            <!--                                                           
                                                            <v-text-field
                                                            label="Non Prenotati"
                                                            v-model="selectedCampaign.filters.nonBooked"
                                                            hide-details
                                                            outlined
                                                            dense
                                                            readonly
                                                            ></v-text-field>
                                                            -->
                                                        </v-col>
                                                    </v-row>
                                                </v-card>                                            
                                            </v-col>                                        
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <!--
                            <v-card class="mt-3">
                                <v-card-title>Messaggi aperti dopo...</v-card-title>
                                <line-chart 
                                    :data="barChartData"
                                    :options="other_settings.line_option"
                                    :style="{ height: (wHeight/2-124)+'px' }"
                                    />
                            </v-card>
                            <v-card class="mt-3">
                                <v-card-title>Clicks</v-card-title>
                                <bar-chart 
                                    :data="barChartData2"
                                    :options="other_settings.bar_option"
                                    :style="{ height: (wHeight/2-124)+'px' }"
                                    />
                            </v-card> 
                            -->                          
                        </v-col>
                        
                        <v-col cols="6" class="mb-2" :style="'max-height:'+(wHeight-124)+'px;overflow-y:auto'">
                            <v-card class="neu-glow">
                                <v-card-title> Dettagli Messaggi <span class="pl-3" v-if="campaignMessages&&campaignMessages.length">({{campaignMessages.length}})</span>
                                    <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            label="Cerca"
                                            color="info"
                                            outlined
                                            hint="ricerca effettuata su nome e/o numero telefonico"
                                            class="float-right"
                                        ></v-text-field>
                                </v-card-title>
                                <!--
                                <div v-if="campaignMessages">
                                    <v-progress-circular
                                        :size="300"
                                        :width="20"
                                        color="info"
                                        class="mt-6"
                                        indeterminate
                                        >
                                    </v-progress-circular>
                                </div>
                                -->
                                <v-data-table
                                
                                :search="search"
                                fixed-header
                                :headers="campaignMessagesHeader"
                                :items="!campaignMessages?[]:campaignMessages.filter(m=>m.phoneNumber.includes(search)||m.firstName.includes(search)||!search)"
                                hide-default-footer
                                :items-per-page="500"
                                class="mt-2 pb-2"
                                :loading="loading?'info':null"
                                no-data-text="Nessun dato presente in archivio"
                                no-results-text="Nessun Risultato estratto"
                                loading-text="Consultazione archivio: attendi..."
                                >
                                    <template v-slot:[`item.clicks`]="{ item }">
                                        <div v-if="item.clicks">
                                            <v-tooltip top v-for="(i,ii) in item.clicks.filter(c=>c.clicked)" :key="ii">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div class="float-left mr-2">
                                                        <v-icon  v-bind="attrs" v-on="on">{{i.icon}}</v-icon>
                                                    </div>
                                                </template>
                                                <span class="ml-2">
                                                    {{i.buttonText+': '+i.clicked}}
                                                </span>  
                                            </v-tooltip>
                                        </div>
                                    </template> 
                                    <template v-slot:[`item.status`]="{ item }">
                                        <div class="d-flex justify-center">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div class="float-left mr-2">
                                                        <v-icon  v-bind="attrs" v-on="on" :color="item.iconColor">{{item.icon}}</v-icon>
                                                    </div>
                                                </template>
                                                <span class="ml-2">
                                                    {{item.status}}
                                                </span>  
                                            </v-tooltip>
                                        </div>
                                    </template>                                        
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>        
        <v-dialog v-model="dialog_inputVideo" max-width="800">
            <v-card class="mx-2 px-2 neu-glow">
                <v-card-title>URL Video  - no youtube URL!! 
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_inputVideo=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>                    
                </v-card-title>
                    <v-card-text>
                        <v-text-field
                        v-model="campaign.URLVideo"
                        label="URL Video"
                        prepend-icon="mdi-video"
                        persistent-hint
                        clearable
                        outlined
                        hint="Solo Formato .mp4"
                        ></v-text-field>
                    </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_create_mktg" max-width="800">
            <v-card class="neu-glow ma-2">
                <v-card-title>
                    ATTENDI...
                </v-card-title>
                <v-card-text>
                    Stiamo creando tutti i messaggi: l'operazione potrebbe richiedere alcuni minuti
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_vuecropper" max-width="800">
            <vuecropper 
            @close="closeCropper"
            @completed="handleCompleted"
            @error="handlerError"
            :uploadFormData="UFD"
            >
            </vuecropper>
        </v-dialog>
        <v-dialog v-model="dialog_saveManualData"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Salva Dati
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading_send" @click="saveManualData()">
                            <v-icon color="success">mdi-content-save</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Dati</span>
                    </v-tooltip>  
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_saveManualData=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>         
                </v-card-title>
                <v-card-text>
                    Attribuisci un nome all'elenco dati appena inseriti: potrai utilizzarli in futuro
                </v-card-text>
                <v-card-text>
                    <v-text-field
                        v-model="manualDataName"
                        solo
                        dense
                        class="text-caption"
                        max-width="200px"
                        hint="Nome Elenco Dati"
                        persistent-hint
                    ></v-text-field>                     
                </v-card-text>
            </v-card>
        </v-dialog> 
        <v-dialog v-model="dialog_addBlackList"
            width="800"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Inserisci in Black List
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :disabled="!newBlackListNumbers" :loading="loading_send" @click="blackList_edit('add',newBlackListNumbers)">
                            <v-icon color="success">mdi-content-save</v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>  
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_addBlackList=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Esci</span>
                    </v-tooltip>         
                </v-card-title>
                <v-card-text>
                    <v-row class="no-gutter">
                        <v-col cols="12">
                            <v-card-text >
                                <v-textarea
                                    v-model="newBlackListNumbers"
                                    clearable
                                    auto-grow
                                    rows="2"
                                    row-height="15"
                                    outlined
                                    color="info"
                                    clear-icon="mdi-close-circle"
                                    label="Numeri in BlackList"
                                    :hint="!newBlackListNumbers?'Inserisci i numeri separati da virgola. Il numero deve contenere anche il prefisso nazionale. Eventuali spazi e \'+\' vengono rimossi':'Dati effettivamente inseriti: '+filteredBlackList()"
                                    persistent-hint
                                ></v-textarea>                                      
                            </v-card-text>
                        </v-col>                        
                    </v-row>
                    
                </v-card-text>
            </v-card>
        </v-dialog>  
        <v-dialog v-model="dialog_confirm"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Confermi Invio Campagna ?
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading_send" @click="alterCampaign(campaignId,'send')">
                            <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma Invio</span>
                    </v-tooltip>  
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirm=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>         
                </v-card-title>
            </v-card>
        </v-dialog>  
        <v-dialog v-model="dialog_delete"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Confermi Cancellazione Campagna ?
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading" @click="alterCampaign('delete')">
                            <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma Cancellazione</span>
                    </v-tooltip>  
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_delete=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>         
                </v-card-title>
            </v-card>
        </v-dialog>   
        <v-dialog 
            eager 
            v-model="dialog_pay"
            width="900"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Effettua Pagamento Campagna Marketing
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_pay=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>         
                </v-card-title>
                <v-card-text>
                    <iframe  :src="payURL" width="850" height="600">
                    </iframe>
                </v-card-text>
            </v-card>
        </v-dialog>    
        <v-dialog 
            v-model="dialog_savedDataShow"
            width="800"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Elenco Destinatari in Archivio <strong class="pl-3" v-if="savedDataArchives&&selectedDataArchiveId"> {{savedDataArchives.find(d=>d.dataId==selectedDataArchiveId).name}}</strong>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click.stop="dialog_savedDataShow=false">
                            <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                        </template>
                        <span>OK</span>
                    </v-tooltip>         
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        fixed-header
                        :headers="savedDataShowHeader"
                        :items="!savedDataGet?[]:savedDataGet"
                        hide-default-footer
                        :items-per-page="500"
                        class="mt-2 pb-2"
                        :loading="loading?'info':null"
                        no-data-text="Nessun dato presente in archivio"
                        no-results-text="Nessun Risultato estratto"
                        loading-text="Consultazione archivio: attendi..."
                        >
                        <template v-slot:[`item.phoneId`]="{ item,index}">
                            <v-btn icon color="error" @click="removeDestinee(index,item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template> 
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog 
            v-model="dialog_errorDestinee"
            width="600"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Errori/Elementi da Attenzionare
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click.stop="dialog_errorDestinee=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>         
                </v-card-title>
                <v-card-text>
                    <ol>
                        <li v-for="(i,ii) in errorDestinee" :key="ii">
                            <v-card class="pa-2">
                                <span class="text-subtitle-2" v-html="i"></span>
                            </v-card>
                        </li>
                    </ol>
                </v-card-text>
            </v-card>
        </v-dialog>
        <Upload :dialog.sync="dialog_upload" :multiple="false" @filesUploaded="processUploadArchive($event)"/> 
        <v-dialog 
            v-model="dialog_uploadedArchive"
            width="900"
            v-if="uploadedArchive"
        >
            <v-card>
                <v-card-title class="text-h5 mb-2">
                Archivio 
                    <v-spacer></v-spacer>
                    <v-text-field
                        class="ml-6"
                        v-if="editArchiveName"
                        solo
                        width="300"
                        dense
                        hide-details
                        v-model="uploadedArchive.name"
                    >
                    </v-text-field>
                    <span v-else class="ml-3" style="width:355px">
                        {{uploadedArchive.name}}
                    </span>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow ml-3" @click.stop="editArchiveName=!editArchiveName">
                            <v-icon :color="editArchiveName?'warning':'info'">mdi-note-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Modifica Nome Archivio</span>
                    </v-tooltip>                    
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" @click="saveEditedArchive()">
                            <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                        </template>
                        <span>Procedi</span>
                    </v-tooltip> 
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_uploadedArchive=false">
                            <v-icon color="info">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>                             
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        fixed-header
                        :headers="archiveEditHeader"
                        :items="!uploadedArchive.payload?[]:uploadedArchive.payload"
                        :items-per-page="20"
                        class="mt-2 pb-2"
                        item-class="py-1"
                        :loading="loading?'info':null"
                        no-data-text="Nessun dato presente in archivio"
                        no-results-text="Nessun Risultato estratto"
                        loading-text="Consultazione archivio: attendi..."
                        >

                        <template v-slot:[`item.name`]="{ item}">
                            <v-text-field
                                solo
                                dense
                                hide-details
                                v-model="item.name"
                            >
                            </v-text-field>
                        </template> 
                        <template v-slot:[`item.phone`]="{ item}">
                            <v-text-field
                                solo
                                dense
                                reverse
                                counter
                                hide-details
                                v-model="item.phone"
                            >
                            </v-text-field>
                        </template> 
                        <template v-slot:[`item.postalCode`]="{ item}">
                            <v-text-field
                                solo
                                dense
                                counter
                                hide-details
                                v-model="item.postalCode"
                            >
                            </v-text-field>
                        </template>                                                                         

                        <template v-slot:[`item.phoneId`]="{ item,index}">
                            <v-btn icon color="error" @click="removeArchiveDestinee(index,item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template> 
                        <template v-slot:[`item.phoneId2`]="{ item}">
                            <v-btn icon color="success" @click="$set(item, 'phone', '39'+item.phone)">
                                <v-icon>mdi-phone-plus</v-icon>
                            </v-btn>
                        </template>                         
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-switch
                        v-model="add39Upload"
                        inset
                        hide-details
                        dense
                        label="Aggiungi 39 a tutti i Numeri"
                    ></v-switch> 
                </v-card-actions>
            </v-card>
        </v-dialog>                            
   </v-sheet>
</template>
<script>
// Validations
import { mapGetters } from "vuex";
import LineChart from "@/components/ChartJS/LineChart";
import BarChart from "@/components/ChartJS/BarChart";
import colors from "vuetify/lib/util/colors";
import vuecropper from "./VueCropper";
import Upload from "./upload";
export default {
    components: {
        LineChart,BarChart,vuecropper,Upload
    },
    data() {
    return {
				settings:{"locale":null,"avatar":null},
				locale:null,
                dialog_confirm:false,
                dialog_delete:false,
                dialog_pay:false,
                dialog_upload:false,
                dialog_saveManualData:false,
                dialog_savedDataShow:false,
                dialog_uploadCSV:false,
                dialog_addBlackList:false,
                dialog_inputVideo:false,
                dialog_create_mktg:false,
                payURL:null,
                campaignsKey:0,
				booking:{},
				customerId:null,
				loading:false,
                loadingOpenDetails:false,
                loadingDetails:false,
                loadingSave:false,
                loadingAlter:false,
                loadingSaveManual:false,
                dialog_uploadedArchive:false,
				faqs:null,
                add39Upload:false,
				requests:null,
				foodStyles:null,
				meals:null,
				locations:null,
				bookableDays:null,
				activeSlotId:null,
				slots:null,
                editArchiveName:false,
                archiveOldName:null,
				bookableDays:null,
				recipients:null,
                uploadedArchive_copy:null,
				wHeight: window.innerHeight,
				wWidth: window.innerWidth,
				dialog_details:false,
				search:null,
				active:1,
                saveDisabled:false,
                loadPercent:0,
                loadInterval:{},
                campaignId:null,
                userDetails:null,
                newCampaign:false,
                calculatedStartDate:new Date(),
				selectedRecipients:null,
				selectedCampaign:null,
                campaignMessages:null,
                campaignStatistics:null,
                statistics:null,
                errorDestinee:[],
                campaigns:[],
                destinee:null,
                campaignDetails:null,
                snackbar:{model:false,color:'',timeout:2000,message:''},
                manualRecipients:null,
                manualNames:null,
                minTime:'08:30',
                //uploadedRecipients:null,
                sourceFilters: ['Filtra dati Archivio', 'Inserisci dati','Usa Archivi','Black List'],
                excludedFilters:["Campagne Precedenti","Black List"],
                sourceFilterTab:0,
                excludedFilterTab:0,
                excludedSingleSelect:null,
                excludedCampaigns:[],
                blackList:null,
                add39:false,
                dialog_errorDestinee:false,
                savedDataGet:null,
                manualDataName:null,
                uploadedArchive:null,
                newBlackListNumbers:null,
                allRecipients:null,
                
                campaignMessagesHeader:[
                     { text: 'Telefono',    value: 'phoneNumber',   align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                     { text: 'Nome',        value: 'firstName',     align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                     { text: 'CAP',         value: 'postalCode',    align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                     { text: 'Km',          value: 'distance',      align: 'end',     sortable: true, class:'text-button font-weight-bold'},
                     { text: 'ETD',         value: 'etd',           align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                     { text: 'ATD',         value: 'atd',           align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                     { text: 'Status',      value: 'status',        align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                     { text: 'TTR',         value: 'TTR',           align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                     { text: 'Clicks',      value: 'clicks',        align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                     //{ text: 'TTC',         value: 'TTC',           align: 'start', sortable: true, class:'text-button font-weight-bold'}
                ],
                savedDataHeader:[
                    { text: 'Nome',         value: 'name',          align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Date',         value: 'TS',            align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Numeri',       value: 'numbersCount',  align: 'end',     sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Seleziona',    value: 'dataId',        align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Cancella',     value: 'dataId2',       align: 'center',  sortable: true, class:'text-button font-weight-bold'}
                ],
                savedDataShowHeader:[
                    { text: 'Nome',         value: 'name',          align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                    //{ text: 'Nazione',      value: 'countryCode',   align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Numero',       value: 'phone',         align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    //{ text: 'CAP',          value: 'postalCode',    align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    //{ text: 'Distance',     value: 'kms',           align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Cancella',     value: 'phoneId',       align: 'center',  sortable: true, class:'text-button font-weight-bold'}
                ], 
                archiveEditHeader:[
                    { text: 'Nome',         value: 'name',         align: 'start',   sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Numero',       value: 'phone',        align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    //{ text: 'CAP',          value: 'postalCode',    align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: '+39',          value: 'phoneId2',     align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Cancella',     value: 'phoneId',      align: 'center',  sortable: true, class:'text-button font-weight-bold'}
                ],   
                blackListHeader:[
                    { text: 'Numero',       value: 'number',       align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                    { text: 'Elimina',      value: 'phoneId',      align: 'center',  sortable: true, class:'text-button font-weight-bold'}
                ], 
                excludedCampaignHeader: [
                { text: 'Nome',         value: 'name',         align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                { text: 'Periodo',      value: 'timeframe',    align: 'center',  sortable: false, class:'text-button font-weight-bold'}, // Temporarily disable sorting
                { text: 'Inviati',      value: 'sent',         align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                { text: 'Click',        value: 'clicks',       align: 'center',  sortable: true, class:'text-button font-weight-bold'},
                { text: 'Click Rate',   value: 'clickrate',    align: 'center',  sortable: false, class:'text-button font-weight-bold'}, // Temporarily disable sorting
            ],
                savedDataArchives:null,
                selectedDataArchiveId:null,
                selectedDataArchiveIdShow:null,
                filters:    {
                            dow:[],
                            origin:[],
                            countryId:[],
                            gender:[],
                            wl:[],
                            meal:[],
                            slot:[],
                            noShow:null,
                            cancelled:null,
                            notBooked:null
                            },                	
                campaign:   {
                            name:"",
                            title:"",
                            body1:"",
                            body2:"",
                            body3:"",
                            startDate: new Date().toISOString().split('T')[0],
                            endDate:new Date().toISOString().split('T')[0],
                            frequency:"week_1",
                            dow:null,
                            sendings:1,
                            maxMessages:1000,
                            daysBeforehand:21,
                            time:"17:30",
                            recipients:0,
                            picture:null,
                            type:"",
                            maxDailyMessages:100,
                            meals:"",
                            slots:"",
                            provisionalAmount:0,
                            templateId:'mktg_links_book',
                            manual:{},
                            daysMissing:35,
                            bonus:null,
                            bonusDuration:7
                            },
        frequencies:    [
                            {"text":"Giornaliera","value":"day_1","short":"1G"},
                            {"text":"Settimanale","value":"week_1","short":"1S"},
                            {"text":"BiSettimanale","value":"week_2","short":"2S"},
                            {"text":"Mensile","value":"month_1","short":"1M"},
                            {"text":"Bimestrale","value":"month_2","short":"2M"},
                            {"text":"Trimestrale","value":"month_3","short":"3M"},
                            {"text":"Quadrimestrale","value":"month_4","short":"4M"},
                            {"text":"Semestrale","value":"month_6","short":"6M"}
                        ],
                        templates:null,
                        /*
        templates:      [
                            {"templateId":"mktg_2links_2rows_book_info","buttons":[{"text":"Prenota","code":"book","link":""},{"text":"Info","code":"info","link":""}]}


                        ],*/
        buttonsGroup:   [
                            {"buttonsGroupCode":"bookInfo", "buttons":[{"text":"Prenota","code":"book"},{"text":"Info","code":"info"},{"text":"Dove Siamo","code":"dir"}]},
                            {"buttonsGroupCode":"yesNo", "buttons":[{"text":"SI","code":"1"},{"text":"NO","code":"0"}]},
                            {"buttonsGroupCode":"bookCall", "buttons":[{"text":"Prenota","code":"book"},{"text":"Chiama","code":"call"}]}
                        ],

		sliders:        [
                            {"name":"Età","min":16,"max":100,"range":[18,80],"step":1,"code":"age","active":0,"types":["default","birthdays","missing"],"remarks":"Esclusi nulli"},
                            {"name":"Distanza Km","min":1,"max":200,"range":[5,50],"step":5,"code":"distance","active":0,"types":["default","birthdays","missing"],"remarks":"Esclusi nulli"},
                            {"name":"Distanza Minuti","min":1,"max":200,"range":[5,60],"step":5,"code":"duration","active":0,"types":["default","birthdays","missing"],"remarks":"Esclusi nulli"},
                            {"name":"Coperti","min":1,"max":100,"range":[2,8],"step":1,"code":"covers","active":0,"types":["default","birthdays","missing"]},
                            {"name":"Bambini","min":0,"max":10,"range":[0,2],"step":1,"code":"children","active":0,"types":["default"]},
                            {"name":"Giorni da Ultima Prenotazione","min":7,"max":168,"range":[28,63],"step":7,"code":"delay","active":0,"types":["default"]},
                            {"name":"Ultima Recensione Rilasciata","min":0,"max":1095,"range":[0,365],"step":365,"code":"review","active":0,"types":["default"],"remarks":"Esclusi nulli"},
                            {"name":"Numero Visite","min":0,"max":20,"range":[1,5],"step":1,"code":"visits","active":0,"types":["default"]},
                            {"name":"Rating Cliente","min":0,"max":5,"range":[1,5],"step":1,"type":"int","code":"rating","active":0,"types":["default","birthdays","missing"],"remarks":"Inclusi nulli"},
                            {"name":"Punteggio Review","min":5,"max":20,"range":[15,19],"step":1,"code":"score","active":0,"types":["default","birthdays","missing"],"remarks":"Esclusi nulli"},
                            //{"name":"Giorni al Compleanno","min":7,"max":60,"range":[7,24],"step":1,"code":"birthdays","active":0}
			            ],/*
		origins:        [
                            {"name":"Segreteria Telefonica","icon":"mdi-face-agent","code":"vm"},
                            {"name":"Instagram","icon":"mdi-instagram","code":"ig"},
                            {"name":"WhatsApp","icon":"mdi-whatsapp","code":"wa"},
                            {"name":"Facebook","icon":"mdi-facebook","code":"fb"},
                            {"name":"Google","icon":"mdi-google","code":"go"},
                            {"name":"Admin","icon":"mdi-account","code":"ad"},
                            {"name":"WalkIn","icon":"mdi-walk","code":"wi"},
                            {"name":"Web","icon":"mdi-web","code":"we"},
                            {"name":"Test","icon":"mdi-dev-to","code":" "}
			            ],
                        */
		origin:null,
		dows:           [
                            {"name":"Lunedì","short":"LU","code":1},
                            {"name":"Martedì","short":"MA","code":2},
                            {"name":"Mercoledì","short":"ME","code":3},
                            {"name":"Giovedì","short":"GI","code":4},
                            {"name":"Venerdì","short":"VE","code":5},
                            {"name":"Sabato","short":"SA","code":6},
                            {"name":"Domenica","short":"DO","code":7}
				        ],
		dow:null,
		genders:        [
                            {"name":"Solo Uomini","code":"male","icon":"mdi-human-male"},
                            {"name":"Solo Donne","code":"female","icon":"mdi-human-female"},
                            {"name":"Sconosciuto","code":"unknown","icon":"mdi-help"}
                        ],
		gender:null,
		waitingLists:   [
						    {"name":"Stati in Lista","code":"1","icon":"mdi-clipboard-list"},
						    {"name":"Subito Confermati","code":"2","icon":"mdi-check"}
					    ],
		noShows:        [
						    {"name":"No Shows","code":"1","icon":"mdi-eye-off"},
						    {"name":"Arrivati","code":"0","icon":"mdi-eye-check"}
					    ],
		cancelleds:     [
					    	{"name":"Cancellati","code":"1","icon":"mdi-delete"},
					    	{"name":"Confermati","code":"0","icon":"mdi-check-circle"}
					    ],
		waitingLists:   [
					    	{"name":"Stati in Lista","code":"1","icon":"mdi-clipboard-list"},
					    	{"name":"Subito Confermati","code":"2","icon":"mdi-check"}
					    ],/*	
		meals:          [
						    {"name":"Pranzo","code":"lunch","icon":"mdi-weather-sunny"},
					    	{"name":"Aperitivo","code":"cocktail","icon":"mdi-weather-sunset"},
                            {"name":"Cena","code":"dinner","icon":"mdi-weather-night"}
					    ],	                     				 
		slots:          [
                            {"name":"19:00","code":"19:00"},
                            {"name":"19:30","code":"19:30"},
                            {"name":"20:00","code":"20:00"},
                            {"name":"20:30","code":"20:30"},
                            {"name":"21:00","code":"21:00"},
                            {"name":"21:30","code":"21:30"},
                            {"name":"22:30","code":"22:00"},
                            {"name":"22:30","code":"22:30"},
                        ],
                        */	                     
		//wl:null,
		
		noShow:false,
		cancelled:false,
		nonBooked:false,

        dialog_vuecropper:false,
        uploadURL:'/settings/upload.php',
        uploadURL_CSV:'/settings/upload_csv.php',
        outputOptions:{
            width: 400,
            height: 200,
            minWidth: 400,
            minHeight: 200,
            maxWidth: 400,
            maxHeight: 200,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high',
        },
        pictureName:null,
        pictureNameRoot:null,
        changedLogo:false,
        cropperOptions:{aspectRatio: 2, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false},
        logo_2:'/static/logos/empty_400_182.png',
        selectedTemplate:null,
        campaignTypes:null,

      downloadProgress: 0,
      uploadProgress: 0,
      bytesLoaded: 0,
      totalBytes: 0,
      stage: '',
      error: null,  


      barChartData: {
      
        labels: ['30 sec','60 sec','90 sec','2 min','5 min','10 min','1 ora'],
        datasets: [{
            label: 'Messaggi Aperti',
            data: [
                    48, 
                    84,
                    128,
                    196,
                    247,
                    370,
                    500
                    ],
            fill: true,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10,
            shadowColor: "rgba(103, 116, 132, 0.5)",
            pointBevelWidth: 3,
            pointHoverRadius: 6,
            pointHoverBevelWidth: 4.5,
            pointHoverInnerGlowWidth: 20,
            pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
            borderWidth: 0,
            pointRadius: 0,
            backgroundColor: colors.teal.accent4
        }]
      },
     barChartData2: {
        labels: ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00'],
        datasets: [{
            label: 'Clicks',
            data: [ 4,12,6,4,2,13,5,3,0,2,24,14,3,2,20,24,12],
            fill: true,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowBlur: 10,
            shadowColor: "rgba(103, 116, 132, 0.5)",
            pointBevelWidth: 3,
            pointHoverRadius: 6,
            pointHoverBevelWidth: 4.5,
            pointHoverInnerGlowWidth: 20,
            borderWidth: 0,
            pointRadius: 0,
            pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
            backgroundColor: colors.amber.accent4
        }]
      },                  
		}
  },
  mounted() {
    // Add the error handler
    this.errorHandler = (e) => {
      if (e.message && e.message.includes('ERR_HTTP_1_1_REQUIRED')) {
        e.preventDefault();
        return true;
      }
    };
    window.addEventListener('error', this.errorHandler);
  },
  
  beforeDestroy() {
    // Clean up the event listener
    window.removeEventListener('error', this.errorHandler);
  },  
	created()
	{
		  
		var la=window.navigator.userLanguage||window.navigator.language;
		this.settings.locale=la;
		this.locale=la;
		this.booking.origin='/db';
		this.bookingId=''
        this.$vuetify.theme.dark = true;//this.settings.options.darkTheme;   
		this.getBasicData()
	},  
    watch : {
        'campaign.type': function(newVal,oldVal)
        {
            if (!this.recipients)
            {
                this.getNewCampaignData();
            }
            else
            {
                console.log(2470,newVal)
                switch(newVal)
                {
                    case 'default':
                    case 'missing':
                    case 'waitinglist':
                        this.recipients=[...this.allRecipients];
                        console.log(2477,this.recipients)
                    break;
                    case 'birthdays':
                        var tmp=this.allRecipients.filter(r=>r.birthdate);
                        console.log(2481,tmp)
                        this.recipients=[...tmp];
                        console.log(2483,this.recipients)
                    break;
                    case 'newsletter':
                        var tmp=this.allRecipients.filter(r=>r.nl);
                        console.log(3420,tmp)
                        this.recipients=[...tmp];
                        console.log(3422,this.recipients)                        
                    break;
                }
            }
        },
        'walkIn.lastName': function(newVal)
        {
            if(newVal)
            this.walkIn.lastName=newVal.toUpperCase();
        },
        'walkIn.firstName': function(newVal)
        {
            if(newVal)
            this.walkIn.firstName=newVal.toUpperCase();
        },        
        'campaign.sendings': function(newVal,oldVal)
        {
            var z=filteredRecipients();
        },
        'campaign.name': function (newVal,oldVal)
        {
        this.saveDisabled=false;
        },
        'campaign.body1': function(newVal,oldVal)
        {
            if (newVal!=oldVal)
            {
                this.campaign.body1=newVal.replace(/(\r\n|\n|\r)/gm, " ")
            }
        },
        'campaign.body2': function(newVal,oldVal)
        {
            if (newVal!=oldVal)
            {
                this.campaign.body2=newVal.replace(/(\r\n|\n|\r)/gm, "&nbsp;")
            }
        },
        'campaign.body3': function(newVal,oldVal)
        {
            if (newVal!=oldVal)
            {
                this.campaign.body3=newVal.replace(/(\r\n|\n|\r)/gm, "&nbsp;")
            }
        },        
        'campaign.sendings': function(newVal,oldVal)
        {
            var w=this.calculatedEndDate;
            console.log(2319,newVal,oldVal,w);
        },  
        'campaign.frequency': function(newVal,oldVal)
        {
            var w=this.calculatedEndDate;
            console.log(2324,newVal,oldVal,w);
        },
        'campaign.dow': function(newVal,oldVal)
        {
            var w=this.calculatedEndDate;
            console.log(2329,newVal,oldVal,w);
        },  
        'campaign.startDate': function(newVal,oldVal)
        {
            var w=this.calculatedEndDate;
            console.log(2334,newVal,oldVal,w);
        },  
        selectedDataArchiveId: function(newVal,oldVal)
        {
            this.getSavedData(newVal);
        },
        sourceFilterTab: function(newVal,oldVal)
        {
            console.log(2862,newVal,oldVal)
            if(newVal==4)
            {
                dialog_upload=true;
            }
            //this.manualNames=null;
            //this.manualRecipients=null;
        },
        excludedFilterTab: function(newVal,oldVal)
        {
            console.log(3237,newVal,oldVal)
            if(newVal==4)
            {
                dialog_upload=true;
            }
            //this.manualNames=null;
            //this.manualRecipients=null;
        },
                
        add39Upload: function(newVal,oldVal)
        {
            console.log(2975,newVal);
            if (newVal)
            {
                var tmp={...this.uploadedArchive_copy};
                var z= tmp.payload.map(obj=>{return {...obj,phone:'39'+obj.phone}})
                console.log(2980,z)
                this.uploadedArchive.payload=[...z];
                console.log(2982,this.uploadedArchive)
            }
            else
            {
                this.uploadedArchive={...this.uploadedArchive_copy}
            }
        }
    },
    computed : {
        ...mapGetters(["settings","other_settings","countries"]),       
        filteredCampaigns: function()
        {
            if(this.campaigns)
            {
                var c=this.campaigns;
                var s=this.search;
                var a=this.active;
                var fltrd=null;
                console.log(3481,c,s,a)
                if(c)
                {
                    //fltrd=!s&&!a?c:!s?c.filter(cc=>cc.active==a&&!cc.ended):c.filter(cc=>cc.name.toLowerCase().includes(s.toLowerCase())||cc.title&&cc.title.toLowerCase().includes(s.toLowerCase()))
                    fltrd=!s?c:!s?c.filter(cc=>!cc.ended):c.filter(cc=>cc.name.toLowerCase().includes(s.toLowerCase())||cc.title&&cc.title.toLowerCase().includes(s.toLowerCase()))
                }
                //var fltrd=c.filter(cc=>(!s&&cc.active==a||(cc.active==a&&s&&(cc.name.toLowerCase().includes(s.toLowerCase())||cc.title&&cc.title.toLowerCase().includes(s.toLowerCase())))))
                //console.log(1957,)
                console.log(3489,c,s,a,fltrd)
                return fltrd;
            }
            else
            {
                return null;
            }
        },
        calculateStartDate: function()
        {
            var startDate=this.campaign.startDate;//'2024-06-25'
            var dowStart=this.campaign.dow;//4
            var d = new Date(startDate);
            console.log(2714,f[1])
            d.setDate(d.getDate() + ((7-d.getDay())%7+dowStart) % 7||7); //calculate the rigth DoW
            console.log(2716,startDate,dowStart,d)
            //this.campaign.startDate=d.toISOString().split('T')[0];   
            //this.calculatedStartDate=d.toISOString().split('T')[0];         
        },
        calculatedEndDate: function()
        {

            var campaignType=this.campaign.type;
            var startDate=this.campaign.startDate;
            if(campaignType=='default'||campaignType=='newsletter')
            {
                var dowStart=this.campaign.dow||1;//4
                var sendings=this.campaign.sendings;//2
                var frequency=this.campaign.frequency||'week_1';//'week_2'
                var d = new Date(startDate+' '+this.campaign.time+':00');
                var nd=new Date();
                console.log(2747,d,nd,startDate,dowStart,sendings,frequency,d.toDateString(),nd.toDateString())
                
                var f=frequency.split('_')
                f[1]*=sendings-1;
                console.log(2762,d,d.getDay(),d.getDay()%7,(((7-(d.getDay())%7)+dowStart) % 7),((((dowStart + 7) - d.getDay()) % 7) ))
                //d.setDate(d.getDate() + (((7-(d.getDay())%7)+dowStart) % 7)); //calculate the rigth DoW
                d.setDate(d.getDate() + ((((dowStart + 7) - d.getDay()) % 7) ));
                console.log(2765,d.toLocaleDateString())
                this.calculatedStartDate=d;//.toISOString().split('T')[0];

                if (d.toDateString() === nd.toDateString())
                {
                    //d.setDate(d.getDate() + 1)
                    this.minTime=nd.getHours()+':'+(parseInt(nd.getMinutes()/5)*5+5);

                }
                else
                {
                    this.minTime='08:30';
                }

                console.log(2767,d,this.calculatedStartDate.toLocaleDateString())
                if(f[1]>0)
                {
                    switch (f[0])
                    {
                        case 'day':
                        d.setDate(d.getDate(d.setDate(d.getDate()+f[1])));
                    break;
                        case 'week':
                        d.setDate(d.getDate(d.setDate(d.getDate()+f[1]*7)));
                    break;  
                    case 'month':
                        d.setDate(d.getDate(d.setMonth(d.getMonth()+f[1])));
                        break;
                    }
                }
            }
            else
            {
                d.setFullYear(date.getFullYear() + 30)
            }
            console.log(2749,d.toLocaleDateString());
            this.campaign.endDate=d.toISOString().split('T')[0];
            //return d.toISOString().split('T')[0];

        },
        calculatedRecipients: function()
        {
            var numbers=null;
            var countNumbers=0;
            var countNames=0;
            var invalidNumbers=null;
            console.log(2959,this.manualNames,this.manualRecipients) //sourceFilterTab
            this.errorDestinee=[];
            switch (this.sourceFilterTab)
            {
                case 0:
                    countNumbers=this.recipients?this.recipients.length:0;
                break;
                case 1:
                    numbers=this.manualRecipients?this.manualRecipients.split(','):null
                    countNumbers=numbers?numbers.length:0;
                    countNames=this.manualNames&&Array.isArray(this.manualNames)?this.manualNames.length:this.manualNames?this.manualNames.split(',').length:0;
                    if (countNumbers)
                    {
                        invalidNumbers= numbers.filter(n=>(n.slice(0, 2)=='39'&&(n.length<11||n.length>12))||n.length<9)
                        console.log(2748,invalidNumbers);
                        if (invalidNumbers&&invalidNumbers.length>0)
                        {
                            var invalidNumbersString=invalidNumbers.join(',');
                            this.errorDestinee.push('I seguenti numeri non sembrano corretti: <br>'+ invalidNumbersString);
                        }
                    }
                    if (countNames>0&&countNames!=countNumbers)
                    {
                        this.errorDestinee.push('Vi sono '+countNumbers+' numeri e '+countNames+'  nomi')
                        console.log(3696,this.errorDestinee)
                    }

                break;
                case 2:
                    countNumbers=this.manualNames&&Array.isArray(this.manualNames)?this.manualNames.length:this.manualNames?this.manualNames.split(',').length:0;
                break;
                case 3:
                    countNumbers=0;
                break;                
            }
            console.log(3696,this.errorDestinee)
            return countNumbers
        },
        errorMessage:function()
        {
            
            //console.log(3607,this.filteredRecipients)
            var txt=[];
            if (this.filteredRecipients&&!this.filteredRecipients.length)
            {
                txt.push('Nessun destinatario Selezionato')
            }
            if (!this.campaign.type)
            {
                txt.push('Manca Tipo Campagna')
            }
            if (!this.campaign.name)
            {
                txt.push('Manca Nome Campagna')
            }
            if (!this.campaign.body1)
            {
                txt.push('Manca Testo 1 Messaggio WhatsApp')
            }
            if (!this.campaign.link)
            {
                txt.push('Manca Link Pulsante')
            }
            if (!this.campaign.picture&&!this.campaign.URLVideo)
            {
                txt.push('Manca Immagine o link Video')
            }            
            if (this.filteredRecipients&&this.filteredRecipients.length>this.campaign.maxMessages&&this.campaign.type=='default')
            {
                txt.push('Superato limite Massimo Messaggi per Invio')
            }
            
            /*                                    
            if (this.campaign.templateId=='bookInfo'&&!this.campaign.link)
            {
                txt.push('Manca URL a Link pulsante Info')
            }
            */
            return txt;           
        },
        uniqueCountries: function()
        {
            if(this.selectedCampaign.filters&&this.selectedCampaign.filters.countryId)
            {
                console.log(3622)
                var z=[...new Map(this.countries.map(item => [item.code, item])).values()].filter(dd=>this.selectedCampaign.filters.countryId.includes(dd.code))
                console.log(3624,z)
                return z;
            }
            else
            {
                return null;
            }
        },
        filteredBlackList:function()
		{
			console.log(3657,this.newBlackListNumbers)
            var z=null;
            //const regex = /\s?\+?/gmi;
            //const regex = /\s?\+?|\r?\n|\r/gmi;
            const regex =/[^0-9,]/gmi;
            z=this.newBlackListNumbers?this.newBlackListNumbers.replace(regex, ''):null;  
            return z;
        },
		filteredRecipients:function()
		{
			//console.log(3697,this.filters,this.recipients,this.sliders)
            var z=null;
            //const regex = /\s?\+?/gmi;
            //const regex = /\s?\+?|\r?\n|\r/gmi;
            const regex =/[^0-9,]/gmi;
            if(this.recipients) //filters.origin
            {
                var cr=null;
                switch (this.sourceFilterTab)
                {
                    case 0:
                        cr=this.recipients.filter	(r=>	(!this.filters.countryId    ||!this.filters.countryId.length  ||this.filters.countryId&&this.filters.countryId.includes(r.country))
                                                        &&(!this.filters.dows       ||!this.filters.dows.length       ||this.filters.dows&&this.filters.dows.some(d=>r.dows&&r.dows.split(',').includes(d.toString())))
														&&(!this.filters.gender     ||!this.filters.gender.length     ||this.filters.gender.includes(r.gender))
														&&(!this.filters.wl         ||!this.filters.wl.length         ||r.wl&&r.wl.includes(this.filters.wl))

                                                        &&(!this.filters.noShow     ||r.noShow&&r.noShow.includes(this.filters.noShow))
														&&(!this.filters.cancelled  ||r.cancelled&&r.cancelled.includes(this.filters.cancelled))                                                        
														//&&(this.filters.origin.includes(r.origin)||this.filters.origin.length==0)
														&&(!this.filters.origin     ||!this.filters.origin.length     ||this.filters.origin.some(d=>r.origin&&r.origin.split(',').includes(d)))
														//&&(this.filters.dows.includes(r.dow)||this.filters.dows.length==0)
														//&&(this.filters.dows&&this.filters.dows.some(d=>r.dows.split(',').includes(d.toString()))||this.filters.dows&&this.filters.dows.length==0)

														//&&(this.filters.wl.includes(d=>r.wl.split(',').includes(d))||this.filters.wl.length==0)
                                                        
                                                        &&(!this.filters.meal||!this.filters.meal.length||this.filters.meal.some(d=>r.meal&&r.meal.split(',').includes(d)))
                                                        &&(!this.filters.slot||!this.filters.slot.length||this.filters.slot.some(d=>r.slot&&r.slot.split(',').includes(d)))
														
                                                        &&(r.age&&r.age>=this.sliders.find(s=>s.code=='age').range[0]&&r.age<=this.sliders.find(s=>s.code=='age').range[1]||this.sliders.find(s=>s.code=='age').active==0)
														&&(r.kms&&r.kms>=this.sliders.find(s=>s.code=='distance').range[0]&&r.kms<=this.sliders.find(s=>s.code=='distance').range[1]||this.sliders.find(s=>s.code=='distance').active==0)
														&&(r.mins&&r.mins>=this.sliders.find(s=>s.code=='duration').range[0]&&r.mins<=this.sliders.find(s=>s.code=='duration').range[1]||this.sliders.find(s=>s.code=='duration').active==0)
														&&(r.minCovers&&r.minCovers>=this.sliders.find(s=>s.code=='covers').range[0]&&r.maxCovers<=this.sliders.find(s=>s.code=='covers').range[1]||this.sliders.find(s=>s.code=='covers').active==0)
														&&(r.minChildren!=null&&r.minChildren>=this.sliders.find(s=>s.code=='children').range[0]&&r.maxChildren<=this.sliders.find(s=>s.code=='children').range[1]||this.sliders.find(s=>s.code=='children').active==0)
														&&(r.delay&&r.delay>=this.sliders.find(s=>s.code=='delay').range[0]&&r.delay<=this.sliders.find(s=>s.code=='delay').range[1]||this.sliders.find(s=>s.code=='delay').active==0)
														&&(r.visits&&r.visits>=this.sliders.find(s=>s.code=='visits').range[0]&&r.visits<=this.sliders.find(s=>s.code=='visits').range[1]||this.sliders.find(s=>s.code=='visits').active==0)
														&&(r.minScore&&r.minScore>=this.sliders.find(s=>s.code=='score').range[0]&&r.maxScore<=this.sliders.find(s=>s.code=='score').range[1]||this.sliders.find(s=>s.code=='score').active==0)
                                                        &&((r.minRating&&r.minRating>=this.sliders.find(s=>s.code=='rating').range[0]&&r.maxRating<=this.sliders.find(s=>s.code=='rating').range[1]||!r.minRating)||this.sliders.find(s=>s.code=='rating').active==0)

                                                        &&(r.review&&r.review>=this.sliders.find(s=>s.code=='review').range[0]&&r.review<=this.sliders.find(s=>s.code=='review').range[1]||this.sliders.find(s=>s.code=='review').active==0)                                                        

														
												)
                                                console.log(3542,cr.length)
                        this.selectedRecipients=cr.map(zz=>zz.countryCode+zz.phone);
                        //this.campaign.recipients=this.selectedRecipients?this.selectedRecipients.length:0;
                        //this.campaign.provisionalAmount=(this.selectedRecipients.length*this.userDetails.WAPrice*this.campaign.sendings)||0;
                        //console.log(3064,cr.map(zz=>zz.noShow),this.filters.noShow,this.selectedRecipients)
                    break;
                    case 1:
                        console.log(3715,this.manualRecipients)
                        z=this.manualRecipients?this.manualRecipients.replace(regex, ''):null;                        
                        if (z)
                        {
                            cr=z.split(',');
                            if (this.add39)
                            {
                                cr=cr.map(n=>'39'+n);
                            }
                            //if (cr)
                            {
                                this.selectedRecipients=cr||[];
                                //this.campaign.recipients=this.selectedRecipients?this.selectedRecipients.length:0;
                                //this.campaign.provisionalAmount=(this.campaign.recipients*this.userDetails.WAPrice*this.campaign.sendings)||0;
                            }
                            console.log(3730,cr,this.campaign.recipients,this.campaign.provisionalAmount)
                        }
                    break;
                    case 2:
                        console.log(3734,this.savedDataGet);
                        z=this.savedDataGet?this.savedDataGet:null;                 
                        if (z)
                        {
                            //this.selectedRecipients=z.map(d=>d.phone)
                            cr=z.map(d=>d.phone.replace(regex, ''))
                            this.selectedRecipients=z.map(d=>d.phone)||[]
                            //this.campaign.recipients=this.selectedRecipients?this.selectedRecipients.length:0;
                            //this.campaign.provisionalAmount=(this.campaign.recipients*this.userDetails.WAPrice*this.campaign.sendings)||0;
                            this.manualNames=z.map(d=>d.name)
                        }
                    break;
                    case 3:
                        z=this.uploadedArchive?[...this.uploadedArchive.payload]:[];
                        console.log(3748,z,z.length)
                        if (z.length)
                        {
                            //this.selectedRecipients=z.map(d=>d.phone)
                            cr=z;
                            this.selectedRecipients=z.map(d=>d.phone)||[]
                            //this.campaign.recipients=this.selectedRecipients?this.selectedRecipients.length:0;
                            //this.campaign.provisionalAmount=(this.campaign.recipients*this.userDetails.WAPrice*this.campaign.sendings)||0;
                            this.manualNames=z.map(d=>d.name)
                            console.log(3757,this.manualNames,this.selectedRecipients)
                        }
                    break;
                  
                }
                console.log(3762,this.excludedCampaigns)
                //Object.entries(myObj).forEach(([key, val]) => console.log(key, val));
                var filteredRecipiens=this.selectedRecipients
                if (this.excludedCampaigns)
                {
                    Object.keys(this.excludedCampaigns).forEach(key => {
                    //console.log(key);                        // the name of the current key.
                    //console.log(campaigns[key]['numbers']);   // the value of the current key.
                    filteredRecipiens=filteredRecipiens.filter(i=>!this.excludedCampaigns[key]['numbers'].includes(i))
                    //console.log(filteredRecipiens);
                    });
                }
                cr=filteredRecipiens;
                //console.log(3776,this.selectedRecipients,filteredRecipiens)
                this.selectedRecipients=filteredRecipiens
                this.campaign.recipients=filteredRecipiens?filteredRecipiens.length:0;
                this.campaign.provisionalAmount=(filteredRecipiens.length*this.userDetails.WAPrice*this.campaign.sendings)||0;                
                //console.log(3780,cr,this.campaign.recipients,this.campaign.provisionalAmount)
				return cr;
			}
			else
			{
				console.log(3785,null)
				return null
			}
		},        
        UFD()
        {
            //let option=this.WA_Options.find(o=>o.optionId=='logoWA');
            if (this.userDetails)
            {
                let option=JSON.parse('{"optionId": "logoWA","description": "Logo Messaggi WhatsApp","value": "Marketing-campaign.jpg","dataType": "nvarchar","size": "800x800","inputType": null,"editableByUser": true}');
                let ufd={'name':option.value,'type':'mkt','subdomain':this.userDetails.subdomain,'optionId':'logoWA','width':option.size.split('x')[0],'height':option.size.split('x')[1]}
                console.log(3796,option)
                console.log(3797,ufd);
                return ufd;
            }
            else{
                return null;
            }
        },
        totalProgress() {
            console.log(3733, this.stage);
            
            if (this.stage === 'uploading') {
                // Maps 0-100% upload to 0-1% total
                return Math.round(this.uploadProgress * 0.01);
            } else if (this.stage === 'downloading') {
                // Maps 0-100% download to 1-94% total
                return Math.round(1 + (this.downloadProgress * 97 / 100));
            } else if (this.stage === 'parsing') {
                return 98;
            } else if (this.stage === 'complete') {
                return 100;
            }
            return 0;
        },
    statusMessage() {
        if (!this.allRecipients)
        {
            switch(this.stage) 
            {
                case 'uploading':
                    return `Sending request... ${this.uploadProgress}%`;
                case 'downloading':
                    return `Downloading: ${this.formattedBytes} / ${this.totalSize}`;
                case 'parsing':
                    return 'Processing data...';
                case 'complete':
                    return `Complete: ${this.allRecipients.length} records loaded`;
                case 'error':
                    return this.error || 'An error occurred';
                default:
                    return '';
            }
        }
        else
        {
            return 'Completed'
        }
    } ,       
          
    
    formattedBytes() {
      const bytes = this.bytesLoaded;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      if (bytes === 0) return '0 Bytes';
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    },
    
    totalSize() {
      const bytes = this.totalBytes;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      if (bytes === 0) return '0 Bytes';
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    },
    

    },
  methods: {

        async savedDataArchive_Delete(dataId)    
        {
			this.loadingDeleteManual=true;
            var archiveName=this.savedDataArchives.find(w=>w.dataId==dataId).name;
			const payload=JSON.stringify({"action":"manualDataArchive_Delete","payload":{"dataId":dataId}});
            const res = await this.$http.post('/mktg/mktg.php', payload);
            this.loadingDeleteManual=false;
            switch (res.data.errorid)
            {
                case '0':
                    
                    this.savedDataArchives=this.savedDataArchives.filter(w=>w.dataId!=dataId)
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='success';
                    this.snackbar.message='Archivio "'+archiveName+'" Cancellato';
					//console.log(2038,this.campaignMessages)
				break;
				case '0006':
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='error';
                    this.snackbar.message='Archivo "'+archiveName+'" non Cancellato: verifica e riprova';
				break;
			}
        },
        async blackList_edit(action,data)    
        {
			this.loadingDeleteManual=true;
			const payload=JSON.stringify({"action":'blackList_'+action,"payload":data});
            const res = await this.$http.post('/mktg/mktg.php', payload);
            this.loadingDeleteManual=false;
            switch (res.data.errorid)
            {
                case '0':
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='success';
                    this.snackbar.message='Blacklist Aggiornata';
					//console.log(2038,this.campaignMessages)
				break;
				case '0006':
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='error';
                    this.snackbar.message='BlackList non aggiornata: verifica e riprova';
				break;
			}
        },        
        removeDestinee(id,phone)
        {
            this.savedDataGet.splice(id, 1)
        },
        removeArchiveDestinee(id,phone)
        {
            this.uploadedArchive.payload.splice(id, 1)
        },        
        payCampaign()
        {
            var amount=this.campaign.provisionalAmount.toFixed(2)
            console.log(2806,amount);
            this.payURL="https://ecommerce.nexi.it/area_demo/step/3/?amount="+amount;
            this.dialog_pay=true;
        },
        formatDT(v,p)
        {
            var o=null;
            v=v?new Date(v):new Date();
            try {
                switch (p)
                {
                    case 'dmy':
                        o={year:'numeric',month:'2-digit',day:'2-digit'}
                    break;
                    case 'dm':
                        o={month:'2-digit',day:'2-digit'}
                    break;
                    case 'dmyhms':
                        o={year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'}
                    break;
                    case 'ddmy':
                        o={weekday: "long",year:'numeric',month:'2-digit',day:'2-digit'}
                    break;                
                    case 'hms':
                        o={hour:'2-digit',minute:'2-digit',second:'2-digit'}
                    break;   
                    case 'hm':
                        o={hour:'2-digit',minute:'2-digit'}
                    break;
                    case 'z':
                        o={year:'numeric',month:'2-digit',day:'2-digit'}
                    break;
                    case 'W':
                        o={weekday:'long'}
                    break; 
                    case 'w':
                        o={weekday:'short'}
                    break;                                                                           
                }
                //console.log(2527,v,p)
                var vv=new Intl.DateTimeFormat('it',o).format(v);
                //console.log(2529,v,p,vv)
                return vv
             } catch (error) {
                console.error('formatDT error:', error, vv);
                return 'Invalid Date';
            }
        },
        startNewCampaign()
        {
            this.newCampaign=true;
            this.getNewCampaignData();
        },
        cloneCampaign(campaignId)
        {
            this.campaign=this.campaigns.find(c=>c.campaignId==campaignId).parameters;
            this.filters=this.campaigns.find(c=>c.campaignId==campaignId).filters;
            this.sliders=this.campaigns.find(c=>c.campaignId==campaignId).sliders;
            this.dialog_details=false;
        },
		async getBasicData()
		{
			this.loading=true;
            
            this.loadInterval = setInterval(() => {
                if (this.loadPercent === 100) {
                return (this.loadPercent = 0)
                }
                this.loadPercent += 1
            }, 150)
            
			//var hostname='bellavida.ibookrestaurant.com';
			//var hostname='tamashi.aibooking.cloud';

			const payload=JSON.stringify({"action":"getBasicData","payload":{"customerId":this.customerId,"bookingId":this.bookingId}});
            const res = await this.$http.post('/mktg/mktg.php', payload);
			//const res = await  axios.post('https://aibooking.cloud/ajax/mktg/mktg.php', payload );
			//clearInterval(this.loadInterval)
            switch (res.data.errorid)
			{
                case '0':
					//document.title = res.data.payloads.settings.brand;
					
					//this.recipients=res.data.payloads.recipients;
                    this.userDetails=res.data.payloads.userDetails;
                    this.campaigns=res.data.payloads.campaigns;
                    this.statistics=res.data.payloads.statistics;
                    this.meals=res.data.payloads.meals;
                    this.slots=res.data.payloads.slots;
                    this.origins=res.data.payloads.origins;
                    this.templates=res.data.payloads.templates;
                    this.campaignTypes=res.data.payloads.campaignTypes;
                    if (res.data.payloads.savedDataArchives)
                        this.savedDataArchives=res.data.payloads.savedDataArchives
					console.log(3957,this.campaigns)

				break;
				case '0006':
				  this.$router.push('/unknown').catch(() => {});
				break;
			}
			this.loading= false;
		},
       
    async getNewCampaignData() {
      this.loading = true;
      this.downloadProgress = 0;
      this.parsingProgress = 0;
      this.stage = 'uploading';
      this.error = null;
      const payload=JSON.stringify({"action":"getNewCampaignData","payload":{"customerId":this.customerId,"bookingId":this.bookingId,"type":"default"}});
      try {
        const response = await this.$http.post('/mktg/mktg.php', payload, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Cache-Control': 'no-cache'
            },
            timeout: 600000, // 10 minutes
            
            // Handle large responses better
            maxContentLength: 100 * 1024 * 1024, // 100MB
            maxBodyLength: 100 * 1024 * 1024,   
            decompress: true,       
          // Track upload progress
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              if (this.uploadProgress === 100) {
                this.stage = 'downloading';
              }
            }
          },
          // Track download progress
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.bytesLoaded = progressEvent.loaded;
              this.totalBytes = progressEvent.total;
              this.downloadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
          // Important: set response type to handle large responses
          responseType: 'json',
          // Increase timeout for large data
          timeout: 300000 // 5 minutes
        });
        
        // Process response
        this.stage = 'parsing';
        var complexData = response.data;
        //console.log(3962,complexData)

        this.allRecipients=complexData.payloads.recipients||[];
        this.blackList=complexData.payloads.blackList||[];
        setTimeout(() => {
        this.recipients = complexData.payloads.recipients;
        }, 1200);        
        //this.recipients=complexData.payloads.recipients;          
        
        // Extract records from complex structure
        // Adjust this based on your actual JSON structure
        
        this.loading = false;
        this.stage = 'complete';
        
      } catch (error) {
        console.error('Error fetching data:', error);
        this.error = error.message || 'An error occurred';
        this.loading = false;
        this.stage = 'error';
        
        // Handle specific error types
        if (error.response) {
          // Server responded with error
          this.error = `Server error: ${error.response.status} - ${error.response.statusText}`;
        } else if (error.request) {
          // Request made but no response
          this.error = 'No response from server';
        }
      }
    },




    handleError(error) {
      this.$vuetify.goTo(0);
      // Show error to user
      console.error('Error:', error);
    },        

        async getSavedData(dataId)
		{
			this.loading=true;
            this.loadInterval = setInterval(() => {
                if (this.loadPercent === 100) {
                return (this.loadPercent = 0)
                }
                this.loadPercent += 5
            }, 400)
			//var hostname='bellavida.ibookrestaurant.com';
			//var hostname='tamashi.aibooking.cloud';

			const payload=JSON.stringify({"action":"getSavedDataDetails","payload":{"dataId":dataId}});
            const res = await this.$http.post('/mktg/mktg.php', payload);
            console.log(3485,res)
			//const res = await  axios.post('https://aibooking.cloud/ajax/mktg/mktg.php', payload );
			clearInterval(this.loadInterval)
            switch (res.data.errorid)
			{
                case '0':
					this.savedDataGet=res.data.payloads.details;
                    console.log(3325,this.selectedDataArchiveIdShow,this.savedDataGet)
                    //if (this.selectedDataArchiveIdShow)
                    {
                        console.log(3328)
                        this.dialog_savedDataShow=true;
                    }

				break;
				case '0006':
				  this.$router.push('/unknown').catch(() => {});
				break;
			}
			this.loading= false;
		},        
		async getDetailsData(c)
		{
			this.loading=true;
            this.campaignMessages=null;

			const payload=JSON.stringify({"action":"campaignMessages_get","payload":{"campaignId":c}});
            const res = await this.$http.post('/mktg/mktg.php', payload);
            this.loadingDetails=false;
            this.loadingOpenDetails=false;
            this.loading=false;
            switch (res.data.errorid)
			{
                case '0':
					this.campaignMessages=res.data.payloads.campaignMessages;
                    this.campaignDetails=res.data.payloads.campaignDetails;
                    this.campaignStatistics=res.data.payloads.campaignStatistics;
					console.log(2038,this.campaignMessages)
				break;
				case '0006':
				  this.$router.push('/unknown').catch(() => {});
				break;
			}
		},        
        openDialogConfirm(campaignId)
        {
            this.campaignId=campaignId;
            this.dialog_confirm=true;
        },
        async alterCampaign(campaignId,action='hold')
        {
            console.log(1470,this.selectedRecipients)
            this.loadingAlter=true;
            this.dialog_confirm=false;
            let payload={"action":action,"campaignId":campaignId}
            console.log(2856,payload)
            let w= await this.updateDB(payload)
            console.log(1481,w);
            this.loading=false;
            this.loadingAlter=false;
            var campaignName=this.campaigns.find(c=>c.campaignId==campaignId).name;
            //console.log(1075,w)
            if(w.errorid=='0')
            {
                console.log(1490,w)
                this.snackbar.model=1;
                this.snackbar.timeout=3000;
                this.snackbar.color='success';
                this.snackbar.message='Modificato Status Campagna';
                switch (action)
                {
                    case 'delete':
                        console.log(1969,campaignId,this.campaigns.length)
                        this.campaigns.splice(this.campaigns.findIndex(item => item.campaignId === campaignId), 1)
                        this.snackbar.message='Cancellata Campagna '+campaignName;
                        console.log(1971,campaignId,this.campaigns.length)
                    break;
                    case 'hold':
                        this.campaigns.find(c=>c.campaignId==campaignId).hold=1;
                        this.snackbar.message='Sospesa Campagna '+campaignName;
                    break;
                    case 'resume':
                        this.campaigns.find(c=>c.campaignId==campaignId).hold=0;
                        this.snackbar.message='Sbloccata Campagna '+campaignName;
                    break;
                    case 'send':
                        this.campaigns.find(c=>c.campaignId==campaignId).approved=1;
                        this.snackbar.message='Autorizzata Campagna '+campaignName;
                    break;
                }
            // this.campaigns.push(campaign);            
            }
        },
        async saveManualData()
		{
			this.loadingSaveManual=true;
            this.campaignMessages=null;

			const payload=JSON.stringify({"action":"manualDataSave","payload":this.convertToObj(this.manualNames.split(','),this.selectedRecipients),'name':this.manualDataName});
            const res = await this.$http.post('/mktg/mktg.php', payload);
            this.loadingSaveManual=false;
            this.dialog_saveManualData=false;
            //this.manualNames=null;
            this.selectedRecipients=null;
            switch (res.data.errorid)
            {
                case '0':
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='success';
                    this.snackbar.message='Dati "'+this.manualDataName+'" Salvati';
					//console.log(2038,this.campaignMessages)
				break;
				case '0006':
                    this.snackbar.model=1;
                    this.snackbar.timeout=2000;
                    this.snackbar.color='error';
                    this.snackbar.message='Dati "'+this.manualDataName+'" Non Salvati: Verifica e Riprova';
				break;
			}
		},         
        async saveCampaign(action='save')
        {
            console.log(1992,this.selectedRecipients,this.campaign)
            this.loadingSave=true;
            if (!this.campaign.frequency)
            {
                this.campaign.frequency='week_1';
            }
            if (this.campaign.frequency=='day_1')
            {
                this.campaign.dow=null;
            }
            if (!this.campaign.picture)
            {
                this.campaign.picture=this.userDetails.defaultPicture;
            }
            if(!this.campaign.link.startsWith('http://')&&!this.campaign.link.startsWith('https://'))
            {
                this.campaign.link='https://'+this.campaign.link;
            }
            var frequency=this.campaign.frequency.split('_');
            var campaign={};
            campaign.parameters=this.campaign;

            if(!this.manualRecipients&&!this.uploadedArchive&&!this.savedDataGet)
            {
                campaign.sliders=this.sliders.filter(ss=>ss.active).map(s=>({name:s.name,code:s.code, range:s.range}))
                var sl=campaign.sliders.reduce(function(map, obj) {
                    map[obj.code] = obj.range;
                    //map['name']=obj.title;
                    return map;
                }, {});
                console.log(2476,sl)
                console.log(2477,campaign);
                console.log(2478,this.filters);                                
                campaign.filters ={...this.filters, ...sl}
            }
            else
            {
                //campaign.manualRecipients=this.manualRecipients.split(',');
                //campaign.manualNames=this.manualNames.split(',');
                //console.log(3172,campaign.manualNames.length,campaign.manualRecipients.length)
                /*
                if(!campaign.manualNames||campaign.manualNames.length!=campaign.manualRecipients.length)
                {
                    this.manualNames=Array(campaign.manualRecipients.length).fill('');
                }
                */
               if(this.uploadedArchive)
               {
                console.log(3654,this.uploadedArchive.payload);
                campaign.manual=this.uploadedArchive.payload
               }
               else
               {
                console.log(3658,this.manualNames,this.selectedRecipients)
                var tmp=Array.isArray(this.manualNames)?this.manualNames:this.manualNames.split(',')
                campaign.manual=this.convertToObj(tmp,this.selectedRecipients);
               }
            }
            //campaign.uploadedRecipients=this.uploadedRecipients;
            if(campaign.parameters.type=='default'||campaign.parameters.type=='newsletter')
            {
                campaign.selectedRecipients=this.selectedRecipients;
            }
            campaign.parameters.frequencyPeriod=frequency[0];
            campaign.parameters.frequencyNumber=frequency[1];
            campaign.approved=action=='send'?true:false;
            //campaign.name=campaign.parameters.name;
            campaign.picture=campaign.parameters.picture;
            
            delete campaign.parameters.frequency;
            console.log(2009,campaign)
            this.loading=true;
            let payload={"action":action,"payload":campaign}
            console.log(2012,payload)
            
            if(campaign.parameters.type=='default'||campaign.parameters.type=='newsletter')
            {
                /*
                this.snackbar.model=1;
                this.snackbar.timeout=20000;
                this.snackbar.color='warning';
                this.snackbar.message='Stiamo creando tutti i messaggi: l\'operazione potrebbe richiedere alcuni minuti';
                */
               this.dialog_create_mktg=true;
            }
            /*
            else
            {
            this.snackbar.timeout=4000;
            this.snackbar.color='success';
            this.snackbar.message='Campagna Creata';                
            }
            */
            let w= await this.updateDB(payload)
            console.log(2014,w);

            this.loadingSave=false;
            this.loading=false;
            this.saveDisabled=true;
            this.dialog_create_mktg=false;
            

            //console.log(1075,w)
            if(w.errorid=='0')
            {
                console.log(2019,w)
                this.snackbar.model=1;
                this.snackbar.timeout=2000;
                this.snackbar.color='success';
                this.snackbar.message='Campagna Salvata';
                campaign.active=true;
                campaign.hold=false,
                campaign.campaignId=w.campaignId;
                campaign.recipients=this.selectedRecipients.length;
                campaign.kCount=campaign.parameters.recipients*campaign.parameters.sendings;
                campaign.read=campaign.sent=campaign.delivered=campaign.failed=campaign.clicks=0
                campaign.active=true;
                //this.campaigns = Object.assign({}, this.campaigns, campaign);
                //this.campaigns=[...this.campaigns, ...campaign];
                console.log(2508,this.campaigns,campaign)
                if(!this.campaigns)
                {
                    this.campaigns=[];
                    console.log(2516, this.campaigns,campaign);
                }
                else
                {
                    this.campaigns.unshift(campaign)
                    this.newCampaign=false;
                }
               /* var campaigns=JSON.stringify(this.campaigns);
                this.campaigns=null;
                this.showMessage(campaigns);
                //this.campaigns.unshift(campaign);
                //await this.$nextTick();                
                console.log(2038,this.campaigns)
                */
            }
        }, 
        addDays(days) {
            var result = new Date();
            result.setDate(result.getDate() + days);
            return result.toLocaleDateString('it-IT',{ month: '2-digit',  day: '2-digit'});
        },
        async updateDB(payload)
        {
            try
            {
                const res = await this.$http.post('/mktg/mktg.php', payload);
                //console.log(1284,res);
                if (res.data.errorid=='0')
                {
                    sessionStorage.setItem('jwt', res.data.jwt);
                }
                else
                {
                    //console.log(1291);
                    //this.$router.push('/auth/login').catch(() => {});
                }
                return res.data;
            } catch(e)
            {
                this.dialog_connection_error=true;
            }
        },     
        openDialogDetails(c)
        {
            this.selectedCampaign=JSON.parse(JSON.stringify(c))
            //this.loadingDetails=true;
            this.loadingOpenDetails=true;
            this.dialog_details=true;
            console.log(4301,c)
            this.getDetailsData(c.campaignId);
        },
        convertToObj(a, b) {
            if (a.length != b.length || 
                a.length == 0 || 
                b.length == 0) {
                return null;
            }
            let results= [];
            a.map((n,i)=>{
                    var result={}
                    result.name=a[i];
                    result.phone= b[i];
                    results.push(result);
            })
            return results;
        },
        openCropper()
        {
            console.log(4321)
            this.dialog_vuecropper=true
        },        
        closeCropper()
        {
            this.dialog_vuecropper=false;
            this.newCampaign=true;
        },
        handleCompleted({ response,form1 } )
        {
        console.log(4331, response,response.data)
        //console.log(185, form1)
        this[form1.name]=response.payload;
        if (response.status=='OK')
        {
            this.changedLogo=true;
            this.snackbar.color='success';
            this.snackbar.message='Modificato Logo';
            this.pictureName=response.pictureName;
            this.campaign.picture=response.pictureName
            this.dialog_vuecropper=false;
            this.newCampaign=true;
            console.log(4343,this.pictureName,this.campaign.picture)
        }
        else
        {
            this.snackbar.color='error';
            this.snackbar.message=response.message;
        }
        this.snackbar.model=true;
        },
        handleError({ message, type, context}) {
            if (type === 'upload') {
                const { request, response } = context
            console.log(409, message, request, response)
            this.snackbar=true;
            this.snackbar.color='error';
            this.snackbar.message=response.message;      
            }
        },
        async processUploadArchive(files)
        {
            console.log(3641,files);
            const formData = new FormData();
            files.forEach(f=>formData.append('file', f))
            formData.append('type','mktg_csv')
            
            //form.append('file', blob, this.filename,this.subdomain,this.iReviewWATemplateId)
            const headers = { 'Content-Type': 'multipart/form-data' };
            console.log(3645,formData,headers)

            this.snackbar.model=1;
            this.snackbar.timeout=3000;
            this.snackbar.color='success';
            this.snackbar.message="Processing.....";

            const res = await this.$http.post(this.uploadURL_CSV, formData,{headers});
            console.log(3742,res)
            if (res.data.errorid=='0')
            {
                this.uploadedArchive=res.data.archive;
                this.uploadedArchive_copy={...res.data.archive};
                this.dialog_uploadedArchive=true;
                
            }
            else
            {
                this.snackbar.model=1;
                this.snackbar.timeout=5000;
                this.snackbar.color='error';
                this.snackbar.message=res.data.message;
            }
            return res.data;            
            
        },
        async saveEditedArchive()
        {
            console.log(3764,this.uploadedArchive);
            const k={...this.uploadedArchive}
            k.action='saveEditedArchive';
            const w=await this.updateDB(k)
            console.log(3768,w);
            if (w.errorid=='0')
            {
                this.dialog_uploadedArchive=false;
                /*
                this.snackbar.model=1;
                this.snackbar.timeout=2000;
                this.snackbar.color='success';
                this.snackbar.message=w.message;
                */
            }
            else
            {
                this.snackbar.model=1;
                this.snackbar.timeout=2000;
                this.snackbar.color='error';
                this.snackbar.message=w.message;
            }

        }      
  }
};
</script>
<style>
.pointer-events-none{
    pointer-events:none;
}
.v-picker--time .v-picker__title__btn{
    height: 56px!important;
    font-size: 50px!important;
}
.v-time-picker-title__time{
    margin-top: -12px!important;
}
</style>